// Auto-generated by scripts/generate-i18n-bundle.js from public/i18n/en.json - do not edit manually.
// This is the guaranteed-available English fallback baked into the app bundle, so the app
// never has to wait on a network request just to render *something* understandable. See
// TranslationBootService for how it's used - it never falls back to any language that isn't
// already loaded synchronously from here.
export const BUNDLED_EN_TRANSLATIONS = {
  "pages": {
    "videoAnalytics": {
      "banner": {
        "title": "Annotation"
      },
      "form": {
        "description": "Please check all the deliverables for every shown stream during the specified period of time.",
        "analyticsIdLabel": "Analytics ID",
        "analyticsIdPlaceholder": "You received the analytics ID with an email",
        "getStreams": "Get Streams",
        "deliverables": "Deliverables",
        "videoTime": "Video Time",
        "startVideoTime": "Start Video Time",
        "endVideoTime": "End Video Time",
        "addFinding": "Add finding",
        "nothingToAnalyze": "Nothing to analyze right now.",
        "visualDescription": "Is this visual seen for the full stream duration? Provide a global status. Add findings when the visual is shown first, last, and optionally in between.",
        "productPlacementDescription": "Is this product placement seen for the full stream duration? Provide a global status. Add findings when the product placement is shown first, last, and optionally in between.",
        "showcaseDescription": "Is this showcase seen for the full stream duration? Provide a global status. Add findings when the showcase is shown first and last.",
        "customDescription": "Is this custom content seen for the full stream duration? Provide a global status. Add findings when the custom content is shown first and last.",
        "contentDescription": "Is this content seen for the full stream duration? Provide a global status. Add findings when the content is shown first and last.",
        "streamType": "Stream Type",
        "creator": "Creator",
        "startDate": "Start Date",
        "endDate": "End Date",
        "campaignRange": "Campaign Range",
        "deliverableProgress": "Deliverable Progress",
        "atLeastTwoFindings": "There should be at least two findings to have a valid result.",
        "streamAnalyticsUpdated": "Stream analytics updated successfully",
        "failedToUpdateStreamAnalytics": "Failed to update stream analytics",
        "noDeliverablesLeft": "No deliverables left to analyze for that stream",
        "globalStatus": {
          "successful": "Successful"
        }
      },
      "annotatorTasks": {
        "banner": {
          "title": "Annotations"
        },
        "table": {
          "analyticsId": "Analytics ID",
          "loadMore": "Load 5 More",
          "noMoreTasks": "No More Tasks",
          "noTaskFound": "No task found with this ID",
          "searchPlaceholder": "Search by analytics ID"
        }
      }
    },
    "invitation": {
      "creatorInvitation": {
        "accepting": "Accepting invitation",
        "accepted": "Invitation accepted",
        "acceptedMessage": "You will be redirected to create a password.",
        "alreadyAccepted": "Invitation already accepted",
        "alreadyAcceptedMessage": "You have already accepted this invitation. Please sign in to continue.",
        "goToSignIn": "Go to sign in",
        "invalidInvitation": "Invalid invitation",
        "invalidInvitationMessage": "The invitation is invalid or has expired.",
        "alreadyInvited": "This creator has already accepted an invitation."
      }
    },
    "admin": {
      "userGroup": {
        "navigationTitle": "User Groups",
        "userGroup": "User Group",
        "tabs": {
          "invitations": {
            "title": "Invitations",
            "invite": "Invite",
            "role": "Role",
            "selectRole": "Select a role to see invitations",
            "campaignUserDescription": "Choose 'Campaign User' if you want to create a new free trial account for a new client.",
            "inviteDisabledMessage": "You cannot invite users for this role from this tab.",
            "roles": {
              "support": "Support User",
              "campaign": "Campaign User",
              "campaignSub": "Campaign Sub User",
              "creator": "Creator User"
            },
            "dialog": {
              "editTitle": "Edit Invitation",
              "createTitle": "Invite User",
              "email": "Email",
              "clientName": "Client Name",
              "message": "Message",
              "sentMessage": "Invitation sent successfully to {{email}}",
              "sentErrorMessage": "Failed to send the invitation email. Link copied to clipboard. You can send it manually or try again later.",
              "emailNotSent": "There was an error sending this invitation as an email. You can share the link with the user manually.",
              "revokedMessage": "Invitation revoked successfully for {{email}}",
              "expiresOn": "Expires on {{expiryDate}}",
              "expiredOn": "Expired on {{expiryDate}}",
              "revokeConfirmationDialog": {
                "title": "Revoke Invitation",
                "message": "Are you sure you want to revoke this invitation? This user will lose access to the platform."
              }
            }
          },
          "userGroups": {
            "title": "User Groups",
            "dialog": {
              "title": "Edit User Group",
              "name": "Name",
              "subscription": "Subscription",
              "addPurchase": "Add Purchase",
              "addCampaignSprint": "Add Campaign Sprint",
              "endRead": "End Read",
              "endWrite": "End Write",
              "extraSeats": "Extra Seats",
              "extraChannels": "Extra Channels",
              "extraCampaigns": "Extra Campaigns",
              "purchases": "Purchases",
              "campaignSprints": "Campaign Sprints",
              "effectiveMaxValues": "Effective Max Values",
              "maxConcurrentCampaigns": "Max Concurrent Campaigns",
              "maxCreatorChannels": "Max Creator Channels",
              "maxSeats": "Max Seats",
              "start": "Start",
              "end": "End",
              "seats": "Seats",
              "channels": "Channels",
              "concurrentCampaigns": "Concurrent Campaigns",
              "noPurchases": "No purchases",
              "effectiveMaxValuesDescription": "Effective max values are the maximum values that can be used by the user group. They are calculated based on the subscription and the purchases of current day ({{currentDay}})."
            }
          },
          "users": {
            "title": "Users"
          }
        }
      },
      "adminCampaigns": {
        "navigationTitle": "Admin Campaigns",
        "banner": {
          "title": "Admin Campaigns"
        }
      },
      "userFeedback": {
        "navigationTitle": "Feedback",
        "detailsTitle": "Feedback details",
        "currentUrl": "Current URL",
        "browserInfo": "Browser info",
        "screenResolution": "Screen resolution",
        "moveTo": "Move to {{status}}",
        "banner": {
          "title": "Feedback"
        }
      },
      "eventAnalytics": {
        "navigationTitle": "Usage & Adoption",
        "banner": {
          "title": "Product Usage & Adoption",
          "subtitle": "Track how customers and creators engage with campaigns, briefings and reports over time."
        },
        "filter": {
          "scope": "Scope",
          "timeRange": "Time Range",
          "thisWeek": "This week",
          "thisMonth": "This month",
          "allTime": "Full period",
          "last7Days": "Last 7 days",
          "last30Days": "Last 30 days",
          "custom": "Custom range",
          "customRange": "Custom range",
          "compare": "Compare",
          "none": "None",
          "previousPeriod": "Previous period",
          "compareCustomRange": "Compare custom range",
          "compareRangePreview": "Compare range",
          "allGroups": "All groups ({{count}})",
          "searchGroups": "Search groups"
        },
        "tabs": {
          "overview": "Overview",
          "kpis": "KPIs",
          "charts": "Charts",
          "groups": "Groups",
          "users": "Users"
        },
        "sections": {
          "completionAdoption": "Completion & Adoption",
          "usage": "Usage",
          "engagement": "Engagement",
          "costs": "Costs",
          "mcp": "MCP"
        },
        "charts": {
          "comingSoonTitle": "Charts are coming soon",
          "comingSoonMessage": "This tab will visualize usage trends over time once it's ready."
        },
        "overview": {
          "journeyChart": {
            "title": "Campaign journey — report & briefing outcomes",
            "subtitle": "Reports and briefings are independent outcomes — a campaign can have either, both, or neither.",
            "campaignsStartedLabel": "Campaigns started",
            "campaignsStartedTooltipLabel": "Campaigns started",
            "campaignsStartedTitle": "Campaigns started",
            "campaignsCompletedLabel": "Campaigns completed",
            "campaignsCompletedTooltipLabel": "Campaigns completed",
            "campaignsCompletedTitle": "Campaigns completed",
            "reportsCreatedLabel": "Reports created",
            "reportsCreatedTooltipLabel": "Reports created",
            "reportsCreatedTitle": "Reports created",
            "briefingsCreatedLabel": "Briefings created",
            "briefingsCreatedTooltipLabel": "Briefings created",
            "briefingsCreatedTitle": "Briefings created"
          },
          "timeChart": {
            "title": "Average time on task",
            "finishCampaignLabel": "Finish campaign",
            "finishCampaignTitle": "Average time to finish a campaign",
            "analyticsOverviewLabel": "Analytics overview",
            "analyticsOverviewTitle": "Average time spent in the analytics overview popup",
            "deliverableViewLabel": "Deliverable view",
            "deliverableViewTitle": "Average time spent in the analytics deliverable view popup",
            "avgTimeTooltipLabel": "Average time"
          }
        },
        "kpis": {
          "campaignCompletionRate": {
            "title": "Campaign Completion Rate",
            "info": "% of started campaigns that were completed"
          },
          "reportAdoptionConversion": {
            "title": "Report Adoption Rate",
            "info": "% of created reports that were published"
          },
          "briefingAdoptionConversion": {
            "title": "Briefing Adoption Rate",
            "info": "% of tagged creators with a briefing"
          },
          "campaignsWithReports": {
            "title": "Campaigns with Reports",
            "info": "% of completed campaigns with a report"
          },
          "campaignsWithBriefings": {
            "title": "Campaigns with Briefings",
            "info": "% of completed campaigns with a briefing"
          },
          "briefingOpenRate": {
            "title": "Briefing Open Rate",
            "info": "% of created briefings that were opened at least once"
          },
          "reportOpenRate": {
            "title": "Report Open Rate",
            "info": "% of created reports that were opened at least once"
          },
          "activeUserGroups": {
            "title": "Active Groups",
            "info": "Distinct user groups with any activity in the selected period."
          },
          "activeUsers": {
            "title": "Active Users",
            "info": "Distinct users active in the selected period through any interface (frontend or MCP connector)."
          },
          "activeUsersFrontend": {
            "title": "Active Users (Frontend)",
            "info": "Distinct users active in the frontend in the selected period."
          },
          "activeUsersMcp": {
            "title": "Active Users (MCP)",
            "info": "Distinct users active through the MCP connector in the selected period."
          },
          "activeUsersAvgDaily": {
            "title": "Avg. Daily Active Users",
            "info": "Average number of users active per day during the selected period."
          },
          "totalUsers": {
            "title": "Total Users",
            "info": "Total number of users across the platform"
          },
          "totalUserGroups": {
            "title": "Total User Groups",
            "info": "Total number of user groups across the platform"
          },
          "activeCampaigns": {
            "title": "Active Campaigns",
            "info": "Campaigns started but not yet completed in the selected period"
          },
          "campaignCreationsStarted": {
            "title": "Campaigns Created",
            "info": "Total campaigns started in the selected period"
          },
          "campaignCreationsFinished": {
            "title": "Campaigns Finished",
            "info": "Total campaigns completed in the selected period"
          },
          "reportsCreated": {
            "title": "Reports Created",
            "info": "Total reports created in the selected period"
          },
          "briefingsCreated": {
            "title": "Briefings Created",
            "info": "Total briefings created in the selected period"
          },
          "avgReportsPerCampaign": {
            "title": "Avg. Reports per Campaign",
            "info": "Reports created ÷ campaigns completed"
          },
          "avgBriefingsPerCampaign": {
            "title": "Avg. Briefings per Campaign",
            "info": "Briefings created ÷ campaigns completed"
          },
          "avgTimeToCampaignCreationFinished": {
            "title": "Avg. Campaign Setup Completion Time",
            "info": "Average time between starting and completing the setup of a campaign."
          },
          "avgTimeInAnalyticsPopupOverview": {
            "title": "Avg. Time in Analytics Overview",
            "info": "Average time spent viewing the analytics overview popup."
          },
          "avgTimeInAnalyticsPopupDeliverableView": {
            "title": "Avg. Time in Deliverable View",
            "info": "Average time spent viewing a campaign's finished report or briefing output."
          },
          "avgViewsPerReport": {
            "title": "Views per Report",
            "info": "Average number of times a created report's analytics were opened."
          },
          "avgViewsPerBriefing": {
            "title": "Views per Briefing",
            "info": "Average number of times a created briefing's analytics were opened."
          },
          "campaignsWithAnalyticsViewed": {
            "title": "Campaigns with Analytics Viewed",
            "info": "% of campaigns whose analytics a user looked at, in the frontend or through the MCP connector. Public report and briefing views don't count."
          },
          "campaignsWithAnalyticsViewedMcp": {
            "title": "Campaigns with Analytics Viewed (MCP)",
            "info": "% of campaigns whose analytics a user looked at through the MCP connector."
          },
          "timeToFirstCampaignCreationFinished": {
            "title": "Time to First Campaign Completed",
            "info": "Time from onboarding until the first campaign was completed."
          },
          "timeToFirstAnalyticsPopupOpened": {
            "title": "Time to First Analytics View",
            "info": "Time from onboarding until the analytics popup was first opened."
          },
          "timeToFirstBriefingCreated": {
            "title": "Time to First Briefing Created",
            "info": "Time from onboarding until the first briefing was created."
          },
          "timeToFirstReportPublished": {
            "title": "Time to First Report Published",
            "info": "Time from onboarding until the first report was published."
          },
          "timeToFirstMcpToolCall": {
            "title": "Time to First MCP Tool Call",
            "info": "Time from onboarding until the first MCP tool call."
          },
          "globalCosts": {
            "title": "Total AI Costs",
            "info": "Total AI costs incurred in the selected period."
          },
          "avgDailyCosts": {
            "title": "Avg. Daily AI Costs",
            "info": "Total AI costs ÷ number of days in the selected period."
          },
          "avgCampaignCosts": {
            "title": "Avg. AI Costs per Campaign",
            "info": "Average lifetime AI costs of campaigns active during the selected period."
          },
          "highestCampaignCosts": {
            "title": "Highest Campaign AI Costs",
            "info": "The highest lifetime AI cost incurred by a single campaign active during the selected period."
          },
          "mcpAdoptionRate": {
            "title": "MCP Adoption Rate",
            "info": "% of active users who used the MCP connector."
          },
          "mcpConnectedUsers": {
            "title": "Connected Users",
            "info": "Users who connected an MCP client (gave consent) in the selected period."
          },
          "mcpSessions": {
            "title": "MCP Sessions",
            "info": "Usage sessions: a user's tool calls with no gap longer than 30 minutes."
          },
          "mcpToolCalls": {
            "title": "Tool Calls",
            "info": "Total MCP tool calls in the selected period."
          },
          "avgMcpToolCallsPerSession": {
            "title": "Avg. Tool Calls per Session",
            "info": "Tool calls ÷ MCP sessions."
          },
          "avgMcpActiveDaysPerUser": {
            "title": "Avg. Active Days per User",
            "info": "Days with MCP activity, per MCP-active user."
          },
          "mcpToolErrorRate": {
            "title": "Tool Error Rate",
            "info": "% of tool calls that failed server-side."
          },
          "mcpToolRejectedRate": {
            "title": "Tool Rejection Rate",
            "info": "% of tool calls rejected as not found, forbidden or invalid input."
          },
          "avgMcpCallDuration": {
            "title": "Avg. Tool Call Duration",
            "info": "Average time a tool call took to answer, not time a user spent."
          }
        },
        "groups": {
          "activeUsersCard": {
            "title": "Active users per group",
            "subtitle": "Segment width represents active users per group."
          },
          "contentCreation": {
            "title": "Content creation by group (top 5)",
            "subtitle": "Totals across all {{count}} groups.",
            "campaignsCreated": "Campaigns created",
            "reportsCreated": "Reports created",
            "briefingsCreated": "Briefings created"
          },
          "table": {
            "title": "User group breakdown",
            "caption": "All KPIs · selected period"
          }
        },
        "users": {
          "mostActiveCard": {
            "title": "Most active users",
            "subtitle": "Segment width represents campaigns completed per user."
          },
          "contentCreation": {
            "title": "Content creation by user (top 5)",
            "subtitle": "Top 5 users per metric. Ring shows each user's share among the top 5 only (excludes the other {{excludedCount}} users).",
            "campaignsCreated": "Campaigns created",
            "reportsCreated": "Reports created",
            "briefingsCreated": "Briefings created"
          },
          "table": {
            "title": "User breakdown"
          }
        }
      },
      "news": {
        "navigationTitle": "News",
        "banner": {
          "title": "News"
        },
        "languageFilterLabel": "Language",
        "createButton": "Create News",
        "deleteError": "News entry could not be deleted",
        "dialog": {
          "titleCreate": "Create news",
          "titleEdit": "Edit news",
          "languageLabel": "Language",
          "priorityLabel": "Priority",
          "titleLabel": "Title",
          "messageLabel": "Message"
        },
        "deleteConfirmTitle": "Delete news",
        "deleteConfirmMessage": "Are you sure you want to delete \"{{ title }}\"?"
      }
    },
    "campaigns": {
      "banner": {
        "title": "Campaigns",
        "description": "Campaigns description"
      },
      "datatable": {
        "copyCampaign": "Copy",
        "deleteCampaign": "Delete campaign",
        "deleteCampaignMessage": "Are you sure you want to delete \"{{ name }}\"?",
        "end": "End",
        "newCampaign": "Create Campaign",
        "noCampaignFound": "No campaign found.",
        "start": "Start"
      }
    },
    "campaignForm": {
      "confirmDialog": {
        "title": "Unsaved Changes",
        "message": "You have unsaved changes. Are you sure you want to leave?",
        "leave": "Leave",
        "stay": "Stay"
      },
      "sectionConfirmDialog": {
        "title": "Unsaved Changes",
        "message": "You have unsaved changes in this section. Are you sure you want to discard them?",
        "discard": "Discard",
        "continueEditing": "Continue Editing"
      },
      "deliverableFlowConfirmDialog": {
        "title": "Unsaved Changes",
        "message": "You have unsaved changes. Are you sure you want to discard them?",
        "discard": "Discard",
        "continueEditing": "Continue Editing"
      },
      "platformChangeConfirmDialog": {
        "title": "Platform Change",
        "message": "Some existing deliverables and goals might not be available for {{platformFeature}}. This deliverable group will also be removed from creators that do not have this platform. Do you want to switch?",
        "confirm": "Switch",
        "cancel": "Cancel"
      },
      "mergeTemplateConfirmDialog": {
        "title": "Select Template",
        "message": "Do you want to select \"{{ctaName}}\" and merge selected creators to it?",
        "confirm": "Select",
        "cancel": "Cancel"
      },
      "buttons": {
        "saveAsDraft": "Save as draft",
        "startCampaign": "Start campaign",
        "saveCampaign": "Save campaign",
        "back": "Back",
        "allSectionsMustBeCompleted": "All sections must be completed to start the campaign."
      },
      "banner": {
        "breadcrumbTitle": "Create new campaign",
        "campaignDashboard": "Campaign Dashboard",
        "title": "New campaign"
      },
      "sections": {
        "cannotSaveUntilCampaignIsLoaded": "You cannot save until the campaign is fully loaded.",
        "couldNotBeSaved": "Campaign could not be saved",
        "couldNotBeCreated": "Campaign could not be created",
        "cannotUpdateEndedCampaign": "You cannot update a finished campaign.",
        "basics": {
          "title": "The Basics",
          "subtitle": "Set campaign details, access and internal notes.",
          "nameLabel": "Campaign name",
          "campaignIcon": "Campaign icon",
          "namePlaceholder": "E.g. Campaign X",
          "timelineLabel": "Timeline",
          "timelineDescription": "Select when the campaign should start and end.",
          "pastDataWarning": "Campaigns can start in the past, but data will only be available if the specific platform channel had already been added to the creator's entity at that time.",
          "startDate": "Start date",
          "startTime": "Start time",
          "endDate": "End date",
          "endTime": "End time",
          "startDatePlaceholder": "Select start date",
          "startTimePlaceholder": "Select start time",
          "endDatePlaceholder": "Select end date",
          "endTimePlaceholder": "Select end time",
          "customerLabel": "Client",
          "customerPlaceholder": "Select client",
          "customerDescription": "Select the client for this campaign, don't worry you can change it later.",
          "addCustomer": "Add client",
          "noCustomersFound": "No clients found",
          "searchCustomer": "Search client",
          "selectOrAddCustomer": "Select or add client",
          "teamsDescription": "If nobody is selected, everyone in your organization can view this campaign. Otherwise, only the selected users and teams can.",
          "teamsAdminOnlyTooltip": "Visibility cannot be used when there are only admin users.",
          "teamsLabel": "Visibility",
          "teamsNoUsersFound": "No users or teams found",
          "teamsPlaceholder": "Select users or teams",
          "teamsSearch": "Search users or teams",
          "teamsUnknownTeam": "Unknown team",
          "teamsUnknownUser": "Unknown user",
          "currencyLabel": "Currency",
          "budgetLabel": "Budget",
          "financeLabel": "Finance",
          "financeDescription": "Set the budget and currency for your campaign here. Currency can not be changed later.",
          "teamSelectLabel": "Team",
          "teamSelectDescription": "Used to filter the campaigns list by team.",
          "selectOrAddTeam": "Select or add team",
          "addTeam": "Add team",
          "searchTeam": "Search team",
          "noTeamsFound": "No teams found"
        },
        "creatorsAndCtas": {
          "title": "Creators & Deliverables",
          "subtitle": "Add global requirements for all creators, then add individual requirements where needed.",
          "globalDeliverables": "Global Deliverable Groups",
          "globalDeliverablesDescription": "Add trackable requirements every creator must complete.",
          "globalBriefingNotesDescription": "Add guidance, instructions, or campaign context that applies to all creators.",
          "globalDeliverableGroupDeleteTooltip": "Global deliverable groups can only be deleted from \"Global Deliverable Groups\" section. You can also exclude creators by editing the deliverable group.",
          "addGlobalDeliverables": "Add Global Group",
          "addNote": "Add Note",
          "editNote": "Edit Note",
          "editName": "Edit Name",
          "editGlobalGroup": "Edit Global Group",
          "editIndividualGroup": "Edit Individual Group",
          "globalTag": "Global",
          "sharedTag": "Shared",
          "globalCustomizedTag": "Global customized",
          "sharedCustomizedTag": "Shared customized",
          "individualTag": "Individual",
          "creatorsCount": "{{count}} Creators",
          "addPayout": "Add Payout",
          "editPayout": "Edit Payout",
          "deleteCreator": "Delete Creator",
          "customBriefingNoteTitle": "Custom Briefing Note",
          "customBriefingNoteDescription": "This overrides the global briefing notes. Applies only to {{creatorName}}.",
          "individualDeliverablesGroupTitle": "Individual Deliverables Group",
          "individualDeliverablesGroupDescription": "Add individual group. Applies only to {{creatorName}}.",
          "addIndividualGroup": "Add Individual Group",
          "globalGroupsCount": "{{count}} Global Deliverable Groups",
          "sharedGroupsCount": "{{count}} Shared Deliverable Groups",
          "expandAll": "Expand All",
          "collapseAll": "Collapse All",
          "ctaSummary": {
            "deliverables": "Deliverables",
            "frequency": "Frequency",
            "kpis": "KPIs",
            "scheduledAt": "Scheduled: {{date}}",
            "repeats": "Repeats: {{count}}x anytime",
            "always": "Every time"
          },
          "convertToGlobalAction": "Convert to global action",
          "globalDeliverable": "Global Deliverable Group",
          "sharedDeliverable": "Shared Deliverable Group",
          "canSaveDisabledMessage": "You must add at least one deliverable and execution for each creator and global deliverable.",
          "copyGlobal": "Copy as global",
          "copyShared": "Copy as shared",
          "copyCreator": "Copy for {{name}}",
          "convertToGlobalActionDialog": {
            "title": "Convert to global action",
            "message": "Do you want to convert this action to a global action?",
            "confirmText": "Convert",
            "cancelText": "Cancel"
          },
          "creatorAndBudget": {
            "title": "Add Creator & Payout",
            "editTitle": "Edit Creator & Payout",
            "noBudget": "no payout",
            "budget": "Payout",
            "continueWithDeliverable": "Continue with Deliverable",
            "noCommonPlatforms": "Selected creators must have at least one common platform to add deliverables.",
            "searchPlaceholder": "Search creators",
            "newCreator": "New creator",
            "platformFilter": "Platform",
            "usedInCampaignFilter": "Used in campaign",
            "searchCampaign": "Search campaign",
            "noCampaignsFound": "No campaigns found",
            "hideAdded": "Hide added",
            "selectAllResults": "Select all {{count}} results",
            "selectAllResultsOne": "Select 1 result",
            "alreadyInCampaign": "Already in campaign",
            "createCreator": "Create creator",
            "loadError": "Creators could not be loaded.",
            "retry": "Retry",
            "selected": "Selected",
            "noCreatorsSelected": "No creators selected yet",
            "samePayout": "Same payout",
            "amount": "amount",
            "applyToAll": "Apply to all",
            "collapseTray": "Collapse selected creators",
            "showTray": "Show selected creators",
            "removeCreator": "Remove {{name}}",
            "addOneCreator": "Add 1 creator",
            "addCreators": "Add {{count}} creators",
            "discardTitle": "Discard selection?",
            "discardMessage": "Discard {{count}} selected creators?",
            "discardMessageOne": "Discard 1 selected creator?",
            "discardConfirm": "Discard",
            "discardCancel": "Keep editing",
            "overwriteTitle": "Overwrite payouts?",
            "overwriteMessage": "Overwrite {{count}} existing payouts?",
            "overwriteMessageOne": "Overwrite 1 existing payout?",
            "overwriteConfirm": "Overwrite",
            "selectedAnnouncement": "{{count}} creators selected",
            "selectedAnnouncementOne": "1 creator selected"
          },
          "removeCreator": {
            "title": "Remove Creator",
            "message": "Are you sure you want to remove \"{{name}}\" from the campaign?",
            "confirmText": "Remove",
            "cancelText": "Cancel"
          },
          "deliverableFlow": {
            "headerSteps": {
              "type": "Type",
              "deliverables": "Deliverables",
              "frequency": "Frequency",
              "goals": "Goals"
            },
            "title": "Create Deliverable Group",
            "editTitle": "Edit {{name}}",
            "noName": "Deliverables cannot be added without a name.",
            "global": "Global",
            "globalAllCreators": "Global / All Creators",
            "modeCannotBeChanged": "All errors must be fixed before switching between global and branch mode.",
            "changesHereOnlyApplyTo": "Changes here apply only to {{creatorName}}.",
            "creatorSelectMenu": {
              "creatorDoesNotHavePlatform": "This creator does not have the selected platform.",
              "lastSelectedCreator": "Last selected creator cannot be unselected.",
              "branchModeCreatorWithErrorsCannotBeUnselected": "Branch mode creator with errors cannot be unselected before fixing the errors.",
              "allCreators": "All Creators",
              "customize": "Customize",
              "editOverride": "Edit override",
              "exitOverride": "Exit override",
              "appliedTo": "Applied to"
            },
            "platformStep": {
              "noGlobalTemplatesFound": "No global templates found.",
              "title": "Add Platform",
              "noCommonPlatforms": "No common platforms found for selected creators.",
              "platformCannotBeChanged": "Platform cannot be changed.",
              "searchGlobalTemplate": "Search global template",
              "selectPlatform": "Select Platform",
              "selectPlatformDescription": "Select the platform feature for this deliverable group",
              "whatShouldBeTracked": "What should be tracked?",
              "youCanAlsoAddPlatform": "You can also add a new platform to {{creatorName}}",
              "urlToProfile": "URL to {{creatorName}}'s profile",
              "warnings": {
                "instagramStory": {
                  "authenticatedCreatorsOnly": "Instagram Stories can only be tracked for authenticated creators.",
                  "first60SecondsOnly": "Only the first 60 seconds of each video will be tracked."
                }
              }
            },
            "deliverableStep": {
              "title": "What needs to happen?",
              "description": "Define the content requirements for this deliverable group",
              "copy": "Copy",
              "detachFromTemplate": "Detach from template",
              "namePlaceholder": "Deliverable group name, e.g. 'Twitch Gaming Stream'",
              "twitchGamingStream": "Twitch Gaming Stream",
              "deliverableDescriptions": {
                "title": "Require the creator to include specific keywords in the title.",
                "talkingPoint": "Require the creator to verbally mention specific keywords during the content.",
                "talkingPointAi": "Require the creator to talk about a topic in their own words.",
                "chatBot": "Trigger a chatbot command automatically during the stream.",
                "chatbotMulti": "Trigger a chatbot command automatically during the stream.",
                "gamePlay": "The creator must play a specific game for a defined duration.",
                "visual": "Require a video overlay that must be visible on screen (not a channel banner).",
                "productPlacement": "Require the creator to show a specific product within the content (e.g., a can or headset).",
                "showcase": "Provide a specific script or sequence of actions the creator should perform during the stream.",
                "audioTracking": "Track spoken keywords or phrases during the content. This tracking is internal and not visible to the creator.",
                "textTracking": "Track specific keywords in chat or on-screen text. This tracking is internal and not visible to the creator.",
                "caption": "Require specific keywords to be included in the caption.",
                "hashTag": "Require the creator to include specific hashtags in the post.",
                "mention": "Require the creator to mention specific profiles in the post.",
                "content": "Provide a specific script or sequence of actions the creator should perform in the video.",
                "message": "Require specific keywords to be included in the text message of his post.",
                "custom": "Manually verify any requirement that cannot be tracked automatically.",
                "description": "Require specific keywords to be included in the description."
              }
            },
            "executionStep": {
              "title": "How often is this deliverable group required?",
              "description": "Choose how often this deliverable group must be fulfilled during the campaign. All posts and streams will be checked and counted regardless of frequency. Any extras exceeding your defined frequency are classified as bonuses.",
              "note": "Note:  Any additional matching content will automatically count as bonus.",
              "executionType": "Type",
              "lockTooltip": "Frequency type cannot be changed in override mode",
              "executionTypes": {
                "unique": "{{date}}",
                "undesignated": "{{count}}x during campaign duration",
                "always": "Always"
              },
              "executionTypeHeaders": {
                "unique": {
                  "title": "Once at a specific time",
                  "description": "Required once on a scheduled date or time."
                },
                "undesignated": {
                  "title": "A set number of times",
                  "description": "Required a specific number of times at any point during the campaign."
                },
                "always": {
                  "title": "Every time content is posted",
                  "description": "Required whenever content is published. There is no fixed number - every post or stream must include these deliverables.",
                  "noInputNeeded": "No additional input needed."
                }
              }
            },
            "kpisStep": {
              "addTargetValues": "Add target values",
              "description": "KPIs are always tracked. Add targets only if minimum goals must be reached.",
              "editTargetValues": "Edit target values",
              "hideTargetValues": "Hide target values",
              "targetSet": {
                "multiple": "{{count}} targets set",
                "single": "{{count}} target set"
              },
              "title": "Define target values (optional)"
            },
            "reviewStep": {
              "description": "Check your deliverable group, review the scoped totals, and give it a name.",
              "finish": "Finish",
              "groupNameLabel": "Group name (internal only)",
              "namePlaceholder": "Name of this deliverable group",
              "title": "Review and Confirm"
            }
          },
          "noGlobalActions": "No global actions added yet.",
          "creatorsLabel": "Creators",
          "creatorsDescription": "Review inherited global requirements and add individual requirements if needed.",
          "selectCreatorsPlaceholder": "Select creators",
          "addCreator": "Add Creator",
          "noCreatorsFound": "No creators found",
          "value": "Value",
          "manage": "Manage",
          "addDeliverables": "Add Deliverable Group",
          "creatorWithoutCta": "This creator has nothing to do. Click on 'Add Deliverables' to add deliverables.",
          "cost": "Cost",
          "allCreators": "Global Actions",
          "deliverables": "Deliverables",
          "deliverable": "Deliverable",
          "rep": "Rep",
          "reps": "Reps",
          "kpi": "KPI",
          "kpis": "KPIs",
          "noDeliverableGroups": "No deliverable groups yet"
        },
        "notes": {
          "title": "Notes",
          "label": "Any final notes?",
          "description": "You can always edit this later.",
          "placeholder": "Add your notes (optional)"
        },
        "currency": {
          "usd": "US Dollar ($)",
          "eur": "Euro (€)"
        },
        "keywordTracking": {
          "title": "Observation (Optional)",
          "subtitle": "Track keywords (text or audio) for internal purposes only. This is not visible to creators.",
          "description": "Track keywords across all the platforms included in the campaign during the campaign period.",
          "addTracking": "Add Tracking",
          "lastSubItemCannotBeDeleted": "Last sub-item of a tracking cannot be deleted"
        }
      },
      "ctaDialog": {
        "platforms": "Platforms",
        "addPlatformTo": "Add platform to {{name}}",
        "description": "Select any platform you want to add. Only platforms available to this creator are shown.",
        "saveAndClose": "Save and close",
        "discardChanges": "Discard changes",
        "done": "Done",
        "addAnotherPlatform": "Add another platform",
        "hidePlatforms": "Hide platforms",
        "dialogHeader": "All changes are applied automatically.",
        "confirmationDialog": {
          "title": "Unsaved changes",
          "message": "Some changes could not be applied. What would you like to do?",
          "discardChanges": "Discard changes",
          "fixProblems": "Fix problems"
        },
        "removeConfirmation": {
          "types": {
            "execution": "Execution",
            "deliverable": "Deliverable",
            "talkingPoint": "Audio Mention",
            "talkingPointAi": "Talking Point",
            "productPlacement": "Product Placement Image",
            "showcase": "Showcase Image",
            "content": "Content Image",
            "custom": "Custom Image",
            "title": "Title",
            "chatbotMulti": "Chatbot and Command",
            "expectedKpi": "Expected KPI"
          },
          "title": "Remove {{type}}"
        },
        "ctaDetails": {
          "name": "Name",
          "message": "Select Creator to share with",
          "createCustom": "Create custom",
          "switchHasError": "Cannot switch because not all the values are valid.",
          "allCreatorCtaCanOnlyBeDisabled": "Platforms that are added under all creators can only be disabled in custom mode.",
          "followingCreatorsHaveCustomValues": "The following creators have custom values set for this {{type}}:",
          "hasNoActiveDeliverables": "{{platformFeature}} has no active deliverables.",
          "copyTo": "Copy to",
          "removeGlobalActionDialog": {
            "title": "Remove",
            "message": "Do you want to remove this platform from global actions only or from every creator as well?",
            "confirmText": "Remove from all creators",
            "cancelText": "Remove from global actions",
            "cancelTooltip": "Incorrect platforms can only be removed from every creator."
          },
          "mode": {
            "global": "Global",
            "custom": "Custom"
          },
          "executions": {
            "instance": {
              "title": "Execution #{{index}}",
              "subtitle": "Execution"
            },
            "executionType": "Type",
            "count": "Count",
            "duration": "Duration",
            "timestamp": "Timestamp",
            "addExecution": "Add execution",
            "required": "At least one execution is required.",
            "addKpi": "Add KPI",
            "frequencyRule": "Frequency rule {{count}}",
            "hasNoActiveExpectedKpis": "{{platformFeature}} has no active expected KPIs.",
            "lastExecutionCannotBeDeleted": "Last execution cannot be deleted",
            "lastExecutionCannotBeDisabled": "Last execution cannot be disabled",
            "lastActiveExecutionCannotBeDeleted": "This execution cannot be deleted because it is the last active execution for the following creators: ",
            "addAnotherFrequencyRule": "Add another frequency rule (advanced)"
          },
          "deliverables": {
            "title": "Deliverables",
            "subtitle": "Everything that is configured here is tracked.",
            "changesAffectAllRepetitions": "Changes here affect all repetitions of this group.",
            "addDeliverable": "Add Deliverable",
            "automaticallyChecked": "Automatically checked",
            "automaticallyCheckedTooltip": "These deliverables are verified automatically in the background using our tracking system.",
            "manuallyChecked": "Manually checked",
            "manuallyCheckedTooltip": "These deliverables cannot be tracked automatically. Results must be reviewed and accepted or rejected manually during the campaign.",
            "required": "At least one deliverable is required.",
            "lastSubItemCannotBeDeleted": "Last sub-item of a deliverable cannot be deleted",
            "lastSubItemCannotBeDisabled": "Last sub-item of a deliverable cannot be disabled",
            "lastDeliverableCannotBeDeleted": "Last deliverable cannot be deleted",
            "lastDeliverableCannotBeDisabled": "Last deliverable cannot be disabled",
            "lastActiveDeliverableCannotBeDeleted": "This deliverable cannot be deleted because it is the last active deliverable for the following creators: ",
            "objective": "Objective",
            "requiredByCampaign": "required by campaign",
            "advanced": {
              "button": "Advanced",
              "sponsoredContentRelevant": "Counts as sponsored content",
              "sponsoredContentRelevantDescription": "Only enabled deliverables are used to calculate sponsored-content time and KPIs."
            },
            "descriptions": {
              "title": "The title deliverable checks the title of a video or the titles of a stream for the specified keywords. The order of the keywords is irrelevant. In the case of a stream, changing titles are also recognized and checked.",
              "gamePlay": "The gameplay deliverable checks the stream to see if the specified game was played for the selected time. Interruptions do not matter as long as the total time is met. The game corresponds to the Twitch category, whereby only real games are taken into account (no “Just Chatting”). The streamer must actively set the game for their stream so that it is recognized by Twitch and thus also here.",
              "chatBot": "The chatbot deliverable checks the chat of a stream for the specified message. It checks exactly for the occurrence of the message and also whether it is within the specified interval.",
              "chatbotMulti": "The chatbot deliverable checks the chat of a stream for the specified message. It checks exactly for the occurrence of the message and also whether it is within the specified interval.",
              "talkingPoint": "The audio mentions deliverable checks the audio track of a stream or social post for the specified content. This scope can be used to check whether certain content has been mentioned or to track specific keywords. The latter can also be done with audio tracking. The difference, however, is that the Audio Mentions deliverable is also to be understood as an assignment for a creator. This means that the creator will be able to see the audio mentions in his briefing.",
              "talkingPointAi": "The talking point deliverable checks the audio track of a stream or social post for a specific topic. This deliverable is optimised to find semantic matches, meaning that even if the creator does not use the same words as the description, results will still be found when talking about the topic.",
              "visual": "The visual deliverable checks whether the specified image is found in a stream or video of a social post. The image should be on the actual video, e.g., a banner or logo. For better results, you must also specify whether the image consists only of text (e.g., logo with lettering), only of a graphic, or a mix of both.",
              "productPlacement": "The product placement deliverable checks whether the specified product can be found in a stream or video of a social post. The term “product” refers to an object that is located within the world of the video (e.g., a bottle standing on a table) rather than being placed on top of the video like a logo. For better results, it is important to upload different images with different perspectives of the same product.",
              "showcase": "The showcase deliverable describes actions that are to be performed during the stream or social post. It is important to describe as precisely as possible what is to happen. In the background, the content of the video and audio tracks is checked and AI is used to determine whether the desired behavior has occurred. For example, the description could be that a creator should take off their shoes during a certain sport and hold them up to the camera while talking about how great the brand is.",
              "textTracking": "Text tracking is a flexible way to search for specific keywords, such as the name of a product, in text elements throughout the entire campaign. Text elements refer to everything that can be read outside of the video, e.g., titles, descriptions, chat messages, hashtags, etc. Text that appears in a video itself is not taken into account. Text tracking is automatically applied to all creators and all possible streams and social posts. Later, in the campaign overview, you can check which keywords appeared in each stream or social post. Text tracking is not included in the calculation of the campaign status, and creators will not be asked to name the keywords in their briefing. This is purely informational tracking.",
              "audioTracking": "Audio tracking is a flexible way to search for specific keywords, such as the name of a product, in the audio track of videos and streams throughout the entire campaign. Audio tracking is automatically applied to all creators and all streams and social posts, if possible. A social post that consists only of a text message, for example, is not included in audio tracking. Later, in the campaign overview, you can check which keywords appeared in each stream or social post. Audio tracking is not included in the calculation of the campaign status, and creators will not be asked to mention the keywords in their briefing. This is purely informational tracking.",
              "caption": "The caption deliverable checks the caption of a social post for specified keywords. The order of the keywords is irrelevant.",
              "hashTag": "The hashtag deliverable checks social posts for the specified hashtags. It does not matter whether the hashtag symbol itself is included or not. The order of the hashtags is also irrelevant.",
              "mention": "The mention deliverable checks social posts for the specified mentions. It does not matter whether the @-symbol itself is included or not. The order of the mentions is also irrelevant.",
              "message": "The message deliverable checks the message of a social post for specified keywords. The order of the keywords is irrelevant.",
              "description": "The description deliverable checks the description of a YouTube stream, video, or short for specified keywords. The order of the keywords is irrelevant.",
              "content": "The content deliverable describes actions that are to be performed during the stream or social post. It is important to describe as precisely as possible what is to happen. In the background, the content of the video and audio tracks is checked and AI is used to determine whether the desired behavior has occurred. For example, the description could be that a creator should take off their shoes during a certain sport and hold them up to the camera while talking about how great the brand is.",
              "custom": "The custom deliverable can be individually customized for anything that cannot be tracked automatically. Any items can be entered there, e.g., uploading channel banners or special instructions to the creator that cannot be mapped with other deliverables. However, the results must be accepted or rejected manually and independently during the campaign runtime."
            },
            "titleDeliverable": {
              "title": "Title",
              "subtitle": "Add one or more requirements that should be included in the title of a stream or social post.",
              "addKeyword": "Add another requirement",
              "placeholder": "Requirement",
              "lastActiveTitleCannotBeDeleted": "This title cannot be deleted because it is the last active title for the following creators: "
            },
            "textDeliverable": {
              "fulfillmentRequirements": "Fulfilled when",
              "allKeywordsRequired": "All requirements appear",
              "anyKeywordRequired": "Any requirement appears",
              "multipleKeywordsHint": "Looks like this may contain multiple requirements. Split them into multiple requirements to check them individually or keep them like this to only count this exact combination."
            },
            "chatbotDeliverable": {
              "title": "Chatbot and Command",
              "subtitle": "Add (a part of) a chatbot message to be sent at a given frequency.",
              "interval": "Interval",
              "text": "Text",
              "addChatbot": "Add Chatbot",
              "placeholder": "Exact message that should be send"
            },
            "chatbotMultiDeliverable": {
              "title": "Chatbot and Command",
              "subtitle": "Define keywords that must appear in chatbot messages, with optional interval constraints.",
              "minInterval": "Min. Interval",
              "maxInterval": "Max. Interval",
              "keyword": "Requirement",
              "addKeyword": "Add another requirement",
              "lastActiveKeywordCannotBeDeleted": "This keyword cannot be deleted because it is the last active keyword for the following creators: "
            },
            "talkingPointsDeliverable": {
              "title": "Audio Mentions",
              "subtitle": "Add one or more brands or products that should be mentioned during a video or stream.",
              "addTalkingPoint": "Add another requirement",
              "placeholder": "Requirement",
              "lastActiveTalkingPointCannotBeDeleted": "This audio mention cannot be deleted because it is the last active audio mention for the following creators: "
            },
            "talkingPointAiDeliverable": {
              "title": "Talking Point",
              "subtitle": "Use this as a briefing on everything that should be talked about and add a full text with all the details.",
              "placeholder": "Topic that should be talked about"
            },
            "productPlacementsDeliverable": {
              "title": "Product Placement",
              "subtitle": "Define a product that should be featured in a video or stream.",
              "addImage": "Add image",
              "placeholder": "Name of the product",
              "lastActiveProductPlacementImageCannotBeDeleted": "This product placement image cannot be deleted because it is the last active product placement image for the following creators: ",
              "fileUploadTitle": "Select multiple pictures of the product"
            },
            "gamePlayDeliverable": {
              "title": "Gameplay",
              "subtitle": "Select a game that must be played for a set amount of time.",
              "name": "Twitch Game",
              "duration": "Duration",
              "placeholder": "The official name of the game",
              "previewTooltip": "Game preview image",
              "noCustomValueAllowed": "No custom value allowed"
            },
            "visualDeliverable": {
              "title": "Visual",
              "subtitle": "Add an image to be displayed as an overlay on top of a video or stream.",
              "types": {
                "mixed": "Mixed",
                "text": "Text",
                "graphic": "Graphic"
              },
              "addVisual": "Add Visual",
              "fileName": "File name",
              "clickTo": "Drop files here or click to",
              "change": "change",
              "browse": "browse",
              "uploadNew": "Upload new",
              "uploading": "Uploading...",
              "fileUploadTitle": "Select logo or overlay to upload"
            },
            "showcaseDeliverable": {
              "title": "Showcase",
              "subtitle": "Define a complex script about what should happen during the stream.",
              "addImage": "Add image",
              "placeholder": "Add a detailed description of what should be done",
              "lastActiveShowcaseImageCannotBeDeleted": "This showcase image cannot be deleted because it is the last active showcase image for the following creators: "
            },
            "customDeliverable": {
              "title": "Custom",
              "subtitle": "For everything that can't be tracked automatically but which you still want to check manually and count as requirement.",
              "addImage": "Add image",
              "placeholder": "Add a detailed description of what should be done",
              "lastActiveCustomImageCannotBeDeleted": "This custom image cannot be deleted because it is the last active custom image for the following creators: "
            },
            "textTrackingDeliverable": {
              "title": "Text Tracking",
              "subtitle": "Every title, chat message, description and so on you want to track that is not officially needed.",
              "addKeyword": "Add another requirement",
              "placeholder": "Requirement",
              "lastActiveTextTrackingCannotBeDeleted": "This text tracking cannot be deleted because it is the last active title for the following creators: "
            },
            "audioTrackingDeliverable": {
              "title": "Audio Tracking",
              "subtitle": "Every audio you want to track that is not officially needed.",
              "addKeyword": "Add another requirement",
              "placeholder": "Requirement",
              "lastActiveAudioTrackingCannotBeDeleted": "This audio tracking cannot be deleted because it is the last active title for the following creators: "
            },
            "captionDeliverable": {
              "title": "Caption",
              "subtitle": "Add one or more requirements that should be included in a caption of a post.",
              "addCaption": "Add another requirement",
              "placeholder": "Requirement",
              "lastActiveCaptionCannotBeDeleted": "This caption cannot be deleted because it is the last active caption for the following creators: "
            },
            "hashTagDeliverable": {
              "title": "Hashtag",
              "subtitle": "Add one or more hashtags that are required.",
              "addHashTag": "Add another requirement",
              "placeholder": "Hashtag that should be included",
              "lastActiveHashTagCannotBeDeleted": "This hashtag cannot be deleted because it is the last active hashtag for the following creators: "
            },
            "mentionDeliverable": {
              "title": "Mention",
              "subtitle": "Add one or more mentions that are required.",
              "addMention": "Add another requirement",
              "placeholder": "Mention that should be included",
              "lastActiveMentionCannotBeDeleted": "This mention cannot be deleted because it is the last active mention for the following creators: "
            },
            "messageDeliverable": {
              "title": "Message",
              "subtitle": "Define the full message, or the parts of it that are required.",
              "addMessage": "Add another requirement",
              "placeholder": "Requirement",
              "lastActiveMessageCannotBeDeleted": "This message cannot be deleted because it is the last active message for the following creators: "
            },
            "descriptionDeliverable": {
              "title": "Description",
              "subtitle": "Define the full video description, or the parts of it that are required.",
              "addKeyword": "Add another requirement",
              "placeholder": "Requirement",
              "lastActiveDescriptionCannotBeDeleted": "This description cannot be deleted because it is the last active description for the following creators: "
            },
            "contentDeliverable": {
              "title": "Content",
              "subtitle": "Define a complex script about what should happen during a video.",
              "addImage": "Add image",
              "placeholder": "Add a detailed description of what should be done",
              "lastActiveContentCannotBeDeleted": "This content cannot be deleted because it is the last active content for the following creators: "
            }
          }
        }
      }
    },
    "campaignDetails": {
      "limitReached": {
        "title": "Limit Reached",
        "message": "You have reached your subscription limit. Please upgrade your subscription to continue viewing campaign analytics."
      },
      "tokenUsageWarning": {
        "title": "Campaign Processing Stopped",
        "message": "There are some issues with this campaign. Processing has stopped. Please contact Shikenso for more information."
      },
      "tabs": {
        "contents": "Contents",
        "creators": "Creators",
        "deliverables": "Deliverables",
        "kpiGoals": "KPI-Goals",
        "kpis": "Performance",
        "observations": "Observations",
        "overview": "Overview",
        "timeline": "Timeline"
      },
      "deliverables": {
        "description": "See the individual deliverables that creators were expected to fulfil in this campaign, as well as the additional tracked observations.",
        "filters": {
          "allDeliverableGroups": "All deliverable groups ({{number}})",
          "allDeliverableTypes": "All deliverable types ({{number}})",
          "allMatchings": "All matchings ({{number}})",
          "allObservations": "All observations ({{number}})",
          "deliverableGroup": "Deliverable group",
          "deliverableStatus": "Deliverable Status",
          "deliverableType": "Deliverable type",
          "matching": "Matching",
          "noDeliverablesSelected": "No deliverables selected",
          "noDeliverables": "No deliverables",
          "noObservationsSelected": "No observations selected",
          "noObservations": "No observations",
          "observationStatus": "Observation Status",
          "searchDeliverableGroup": "Search deliverable group",
          "searchDeliverableType": "Search deliverable type",
          "title": "Filters"
        },
        "groupByContent": "Group by content",
        "groupedTablePlaceholder": "The grouped by content table will be added in a follow-up change.",
        "includePlanned": "Include Planned",
        "table": {
          "date": {
            "always": "Always",
            "anyTime": "any time ({{executionOrder}}.)"
          }
        },
        "tabs": {
          "contents": "Contents",
          "deliverables": "Deliverables"
        }
      },
      "observations": {
        "description": "See the individual observations that were tracked for creators in this campaign.",
        "filters": {
          "allObservations": "All observations ({{number}})",
          "noObservationsSelected": "No observations selected",
          "observationStatus": "Observation Status",
          "title": "Filters"
        }
      },
      "kpiGoals": {
        "description": "See how your matched contents perform against defined campaign targets.",
        "filters": {
          "allDeliverableGroups": "All deliverable groups ({{number}})",
          "allKpiTypes": "All KPIs ({{number}})",
          "kpiGoalStatus": "KPI-Goal Status",
          "searchDeliverableGroup": "Search deliverable group",
          "searchKpiType": "Search KPI type",
          "title": "Filters"
        }
      },
      "contents": {
        "description": "See the actual posts and streams that matched your campaign deliverables.",
        "filters": {
          "title": "Filters",
          "allMatchings": "All matchings ({{number}})",
          "contentStatus": "Content Status",
          "onlyWithObservationFindings": "Only with observation findings",
          "searchPlaceholder": "Search for title, caption or description"
        }
      },
      "creators": {
        "listView": "List view",
        "gridView": "Grid view",
        "filters": {
          "title": "Filters",
          "allInvitations": "All invitations ({{count}})",
          "invited": "Invited",
          "uninvited": "Uninvited",
          "allBriefings": "All briefings ({{count}})",
          "briefed": "Briefed",
          "unbriefed": "Unbriefed",
          "allStatuses": "All statuses ({{count}})",
          "allGood": "All good",
          "critical": "Critical",
          "attention": "Attention",
          "notStarted": "Not started"
        },
        "table": {
          "creator": "Creator",
          "invited": "Invited",
          "briefed": "Briefed",
          "payout": "Payout",
          "status": "Status",
          "platforms": "Platforms",
          "issueCount": "({{count}} issues)"
        },
        "popup": {
          "allGoodMessage": "All requirements fulfilled so far",
          "notStartedMessage": "{{name}} has not started yet",
          "matchedContent": "Fulfilled Content",
          "plannedContent": "Planned Content"
        }
      },
      "overview": {
        "noTargetSet": "No target set",
        "currentProgress": "Current progress",
        "campaignHealth": "Campaign Health",
        "contentStatus": "Content Status",
        "kpiGoalStatus": "KPI Goal Status",
        "failedContents": "{{count}} Not Fulfilled Content",
        "missingContents": "{{count}} Missing Content",
        "problemContents": "{{count}} Partially Fulfilled Content",
        "goalsBelowTarget": "{{count}} Goals Below Target",
        "goalsUnavailable": "{{count}} Goals Unavailable",
        "contentExecution": "Content Execution",
        "contentExecutionTooltip": "Content is, for example, a Twitch stream and consists of deliverables such as talking points, title, or gameplay, and goals such as average viewers.",
        "contentTypes": "Content Types",
        "matchedContentStatus": "Matched Content Status ({{count}})",
        "matchedDeliverablesBreakdown": "Matched Deliverables Breakdown",
        "matchedKpiGoalPerformance": "Matched KPI Goal Performance",
        "progress": "Progress"
      },
      "filter": {
        "scope": "Scope",
        "allPlatforms": "All platforms",
        "allCreators": "All creators",
        "timeRange": "Time Range",
        "thisWeek": "This week",
        "thisMonth": "This month",
        "allTime": "Full campaign duration",
        "last7Days": "Last 7 days",
        "last30Days": "Last 30 days",
        "custom": "Custom",
        "customRange": "Custom range"
      },
      "export": {
        "share": "Share",
        "shareSettings": "Share Settings",
        "generalInformation": "General Information",
        "generalAnalytics": "General Analytics",
        "detailedAnalytics": "Detailed Analytics",
        "publishing": "Publishing",
        "sharingStatus": "Sharing Status",
        "timeRange": "Time Range",
        "timeRangeSubtitle": "Choose the time frame you want to share.",
        "insightLevel": "Insight Level",
        "insightLevelSubtitle": "Choose how deep someone can explore your analytics.",
        "overviewOnly": "Overview Only",
        "overviewOnlyDescription": "No analytics popups will be shown",
        "analyticsSummary": "Analytics Summary",
        "analyticsSummaryDescription": "Open analytics popup and see the summary, but no findings.",
        "fullAnalytics": "Full Analytics",
        "fullAnalyticsDescription": "Access full analytics including findings and timestamps.",
        "visibleData": "Visible Data",
        "visibleDataSubtitle": "Control which data will appear in the shared dashboard.",
        "tabs": "Tabs",
        "tabsSubtitle": "Decide what tabs you want to include.",
        "tabsWarning": "No tabs will be shown.",
        "general": "General",
        "generalSubtitle": "Decide if you want to share budget and status information.",
        "platformsSubtitle": "Excluded platforms and their deliverable groups will not be shown anywhere.",
        "platformsWarning": "No platforms will be shown.",
        "kpisSubtitle": "Excluded KPIs will not be shown as goals or performance anywhere.",
        "kpisWarning": "No KPIs will be shown.",
        "creatorsSubtitle": "Excluded creators will not be shown in any analytics.",
        "creatorsWarning": "No creators will be shown.",
        "campaignPublished": "Your campaign is published.",
        "campaignNotPublished": "Your campaign is not published.",
        "campaignNeedsRepublishing": "Your campaign is published but latest changes are not saved yet.",
        "published": "Published",
        "publish": "Publish",
        "republish": "Republish",
        "unpublished": "Unpublished",
        "unpublish": "Unpublish",
        "displayName": "Display Name",
        "link": "Link",
        "linkCopied": "Link copied to clipboard",
        "accessLevel": "Access Level",
        "platforms": "Platforms",
        "creators": "Creators",
        "generalItems": "General Items",
        "kpis": "KPIs",
        "kpiStatus": "KPI Status",
        "deliverableStatus": "Deliverable Status",
        "budget": "Budget",
        "copyLink": "Copy Link",
        "copiedLink": "Link Copied",
        "successfullyPublishedAndLinkCopied": "Campaign successfully published. Link copied to clipboard",
        "successfullyUnpublished": "Campaign successfully unpublished",
        "contentTypes": "Content Types",
        "contentTypesSubtitle": "Excluded content types will not be shown as contents, deliverables or goals.",
        "status": "Status",
        "statusSubtitle": "Excluded status will not be shown as contents, deliverables or goals.",
        "observationStatus": "Observation Status",
        "contentStatus": "Content Status",
        "kpiGoalStatus": "KPI goal status",
        "sharedReports": "Shared Reports",
        "addReport": "Add Report",
        "reportName": "Report {{count}}",
        "cloneExport": "Clone Report",
        "cloneName": "{{name}} (Copy)",
        "cloneNameWithCount": "{{name}} (Copy {{count}})",
        "done": "Done",
        "fullCampaignRange": "Full Campaign",
        "customConfigs": "{{count}} custom configs",
        "noCustomConfigs": "no custom configs",
        "publishError": "Failed to publish the shared report",
        "unpublishError": "Failed to unpublish the shared report",
        "saveError": "Failed to save the shared report",
        "loadError": "Failed to load shared reports",
        "createError": "Failed to create the shared report",
        "deleteError": "Failed to delete the shared report",
        "orderUpdateError": "Failed to save the new report order",
        "platformFeatureKpisError": "Failed to load platform feature KPIs",
        "nameNotUniqueError": "Report name must be unique.",
        "confirmDialog": {
          "title": "Unsaved changes",
          "message": "You have unsaved changes. Are you sure you want to discard them?",
          "discardChanges": "Discard changes",
          "goBack": "Go back"
        },
        "deleteDialog": {
          "title": "Delete shared report",
          "message": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone."
        }
      },
      "banner": {
        "export": "Export",
        "editCampaign": "Edit Campaign",
        "notesHint": "You can edit the campaign to add notes.",
        "owner": "Owner",
        "client": "Client",
        "payout": "Payout",
        "reprocess": "Reprocess",
        "reprocessSuccess": "Campaign analytics reprocess started successfully",
        "reprocessError": "Failed to start campaign analytics reprocess",
        "tokens": "Tokens"
      },
      "creatorOverview": {
        "briefing": "Briefing",
        "briefingDescription": "A personal campaign briefing with general information.",
        "campaignOverview": "Campaign Overview",
        "campaignOverviewDescription": "What does this campaign include and what is your current progress?",
        "contents": "Contents",
        "contentFormats": "Content Formats",
        "campaignRequirements": "Campaign Requirements",
        "progress": "Progress",
        "viewAllPlannedContents": "View all planned contents",
        "alwaysRequired": "Always required",
        "alwaysRequiredDescription": "These requirements apply to all content during campaign.",
        "nextUp": "Next Up",
        "nextUpDescription": "Your next scheduled campaign activities.",
        "upcomingTasks": "Upcoming Tasks",
        "upcomingTasksDescription": "Campaign activities without specified date.",
        "moreRequired": "more required",
        "showMore": "Show {{count}} more",
        "showLess": "Show less",
        "today": "Today",
        "tomorrow": "Tomorrow"
      },
      "creatorTimeline": {
        "status": "Status"
      },
      "calendar": {
        "startTime": "Start Time",
        "endTime": "End Time"
      },
      "kpis": {
        "description": "See all the KPIs of non-bonus contents you want. Use the scope to filter for dates, platforms and creators.",
        "filters": {
          "allKpis": "All KPIs ({{number}})",
          "searchKpi": "Search KPI"
        },
        "table": {
          "avg": "Avg",
          "avgTooltip": "Average KPI value across matched non-bonus contents in the selected scope.",
          "base": "Base",
          "baseTooltip": "Average performance of selected creator(s) over the last 30 days.",
          "baseSponsoredTooltip": "Average performance of selected creator(s) over the last 30 days. This includes both sponsored and non-sponsored content.",
          "campaign": "Campaign",
          "baseline": "Baseline",
          "baselineTooltip": "This is the average performance of selected creator(s) for the last 30 days.",
          "max": "Max",
          "maxTooltip": "Highest KPI value from a matched non-bonus content in the selected scope.",
          "platform": "Platform",
          "total": "Total",
          "totalTooltip": "Total KPI value across matched non-bonus contents in the selected scope."
        },
        "pin": "Pin",
        "unpin": "Unpin",
        "kpis": "KPIs",
        "ctas": "Deliverables",
        "globalStatus": "Global Status",
        "views": "Views",
        "totalMediaValue": "Media Value",
        "mediaValue": "Media Value",
        "averageViewers": "Average Viewers",
        "avgViewers": "Average Viewers",
        "peakViewers": "Peak Viewers",
        "totalWatchedHours": "Watched Hours",
        "sponsoredAvgViewers": "Sponsored Average Viewers",
        "sponsoredAverageViewers": "Sponsored Average Viewers",
        "sponsoredPeakViewers": "Sponsored Peak Viewers",
        "sponsoredTotalWatchedHours": "Sponsored Watched Hours",
        "likes": "Likes",
        "comments": "Comments",
        "engagements": "Engagements",
        "engagementRate": "Engagement Rate",
        "engagementRateViews": "Engagement Rate (Views)",
        "shares": "Shares",
        "impressions": "Impressions",
        "quotes": "Quotes",
        "retweets": "Retweets",
        "predictedImpressions": "Predicted Impressions",
        "reach": "Reach",
        "budget": "Budget",
        "budgetInformation": "Those values are the ones entered during campaign creation: The costs of all creators divided by budget. You can change those values by editing the campaign.",
        "noKpisSet": "No Expected KPIs set",
        "progressOfExpectedKpis": "Progress of expected KPIs"
      },
      "table": {
        "lastProcessed": "Last Processed",
        "kpiStatus": "KPIs",
        "ctaStatus": "Deliverables",
        "pay": "Pay",
        "viewCreator": "View Creator",
        "creatorCampaignExport": {
          "createBriefing": "Create Briefing",
          "enableBriefing": "Enable Briefing",
          "disableBriefing": "Disable Briefing",
          "copyBriefingUrl": "Copy Briefing URL",
          "openBriefing": "Open Briefing",
          "viewBriefingNotes": "View Briefing Notes",
          "successfullyCreated": "Briefing successfully created for {{creatorName}} and its URL is copied to clipboard",
          "successfullyEnabled": "Briefing successfully enabled for {{creatorName}} and its URL is copied to clipboard",
          "successfullyDisabled": "Briefing successfully disabled for {{creatorName}}",
          "successfullyCopiedUrl": "Briefing URL successfully copied for {{creatorName}}"
        }
      },
      "ctaAnalytics": {
        "table": {
          "notAvailable": "Not available",
          "actualStartDate": "Actual start date",
          "actualDuration": "Actual duration",
          "plannedStartDate": "Planned start date",
          "executed": "Executed",
          "planned": "Planned",
          "performance": "Performance",
          "sponsoredContent": "Sponsored Content",
          "lastTitleOfStream": "Last title of the stream",
          "plannedDate": "Planned date",
          "plannedDuration": "Planned duration",
          "sponsoredContentDuration": "Sponsored content duration",
          "sponsoredContentStartDate": "Sponsored content start date",
          "noKpiStatusForBonusStreams": "No KPI status for bonus streams"
        },
        "details": {
          "backToOverview": "Back to overview",
          "trackings": "Trackings",
          "observations": "Observations",
          "detected": "Detected",
          "searchPlaceholder": "Search deliverables, trackings or KPIs",
          "excludedFromSponsoredContent": "This deliverable is excluded from sponsored-content time and KPI calculations",
          "kpiGoals": {
            "title": "KPI-Goals"
          },
          "deliverables": {
            "evaluatedAgainst": "Evaluated against:",
            "groupName": "Group name:",
            "always": "Always",
            "anyTimeDuringCampaign": "Any time during campaign",
            "matching": {
              "bonus": "Bonus",
              "matched": "Matched",
              "matchedBestResult": "Matched, best result",
              "missing": "Missing",
              "planned": "Planned",
              "unrelated": "Unrelated"
            },
            "seeAlso": "See also:",
            "title": "Evaluation Context"
          },
          "graph": {
            "viewers": "viewers",
            "viewersTitle": "Viewers",
            "viewerCountOverTime": "Viewer Count Over Time",
            "findingsOverTime": "Findings over time",
            "productVisibleLegend": "Product visible · width = duration"
          },
          "title": {
            "title": "Title",
            "totalCount": "Total count",
            "titleOverTime": "Title over time",
            "titleChanges": "Title changes",
            "time": "Time",
            "videoTime": "Video Time",
            "message": "Message"
          },
          "chatBot": {
            "title": "Chatbot",
            "totalCount": "Total count",
            "chatbotOverTime": "Chatbot over time",
            "chatbotChanges": "Chatbot changes",
            "time": "Time",
            "videoTime": "Video Time",
            "message": "Message",
            "user": "User"
          },
          "chatBotMulti": {
            "title": "Chatbot and Command",
            "totalCount": "Total count",
            "time": "Time",
            "videoTime": "Video Time",
            "message": "Message",
            "user": "User"
          },
          "talkingPoint": {
            "title": "Audio Mention",
            "totalCount": "Total count",
            "talkingPointOverTime": "Audio Mention over time",
            "talkingPointChanges": "Audio Mention changes",
            "time": "Time",
            "videoTime": "Video Time",
            "message": "Message"
          },
          "talkingPointAi": {
            "title": "Talking Point",
            "totalCount": "Total count",
            "talkingPointAiOverTime": "Talking Point over time",
            "talkingPointAiChanges": "Talking Point changes",
            "time": "Time",
            "videoTime": "Video Time",
            "message": "Message",
            "source": "Source",
            "sourceType": {
              "transcript": "Transcript",
              "chat": "Chat"
            },
            "sentimentType": {
              "positive": "Positive",
              "neutral": "Neutral",
              "negative": "Negative"
            }
          },
          "audioTracking": {
            "title": "Audio tracking",
            "totalCount": "Total count",
            "audioTrackingOverTime": "Audio tracking over time",
            "audioTrackingChanges": "Audio tracking changes",
            "time": "Time",
            "videoTime": "Video Time",
            "message": "Message"
          },
          "textTracking": {
            "title": "Text tracking",
            "totalCount": "Total count",
            "textTrackingOverTime": "Text tracking over time",
            "textTrackingChanges": "Text tracking changes",
            "time": "Time",
            "videoTime": "Video Time",
            "message": "Message",
            "source": "Source",
            "sourceType": {
              "chat": "Chat",
              "title": "Title",
              "caption": "Caption",
              "hashtag": "Hashtag",
              "description": "Description",
              "message": "Message",
              "mention": "Mention"
            }
          },
          "gamePlay": {
            "title": "Gameplay",
            "totalCount": "Total count",
            "gamePlayOverTime": "Gameplay over time",
            "gamePlayChanges": "Gameplay changes",
            "time": "Time",
            "message": "Message",
            "gameName": "Game",
            "start": "Start time",
            "end": "End time",
            "duration": "Total duration"
          },
          "visual": {
            "title": "Visuals",
            "totalCount": "Total count",
            "visualOverTime": "Visual over time",
            "visualChanges": "Visual changes",
            "time": "Time",
            "message": "Message",
            "videoTime": "Video time",
            "status": "Status"
          },
          "showcase": {
            "title": "Showcase",
            "totalCount": "Total count",
            "visualOverTime": "Showcase over time",
            "visualChanges": "Showcase changes",
            "time": "Time",
            "message": "Message",
            "videoTime": "Video time",
            "status": "Status"
          },
          "custom": {
            "title": "Custom",
            "totalCount": "Total count",
            "visualOverTime": "Custom over time",
            "visualChanges": "Custom changes",
            "time": "Time",
            "message": "Message",
            "videoTime": "Video time",
            "status": "Status",
            "manualAcceptRejectNote": "Custom deliverables do not have analytics data and they require manual accept/reject."
          },
          "productPlacement": {
            "title": "Product Placements",
            "totalCount": "Total count",
            "visualOverTime": "Product Placement over time",
            "visualChanges": "Product Placement changes",
            "message": "Message"
          },
          "findingCards": {
            "sort": "Sort:",
            "sortTime": "Time",
            "sortLongestVisible": "Longest visible",
            "realTime": "Real time",
            "videoTime": "Video time",
            "openOnPlatform": "Open on platform",
            "noFindings": "There are no findings.",
            "moreActions": "More actions",
            "enlargeImage": "Enlarge image",
            "noImage": "No image available",
            "imageAlt": "Finding {{number}}",
            "summaryCountOne": "{{count}} finding",
            "summaryCountOther": "{{count}} findings",
            "summaryVisibleInTotal": "{{duration}} visible in total"
          },
          "caption": {
            "title": "Caption",
            "totalCount": "Total count"
          },
          "hashTag": {
            "title": "Hashtag",
            "totalCount": "Total count"
          },
          "mention": {
            "title": "Mention",
            "totalCount": "Total count"
          },
          "message": {
            "title": "Message",
            "totalCount": "Total count"
          },
          "description": {
            "title": "Description",
            "totalCount": "Total count"
          },
          "content": {
            "title": "Content",
            "totalCount": "Total count",
            "videoTime": "Video time",
            "status": "Status",
            "visualOverTime": "content over time",
            "visualChanges": "content changes",
            "time": "Time",
            "message": "Message"
          }
        },
        "kpi": {
          "averageViewers": "Average Viewers",
          "avgViewers": "Average Viewers",
          "peakViewers": "Peak Viewers",
          "totalWatchedHours": "Watched Hours",
          "sponsoredAvgViewers": "Sponsored Average Viewers",
          "sponsoredAverageViewers": "Sponsored Average Viewers",
          "sponsoredPeakViewers": "Sponsored Peak Viewers",
          "sponsoredTotalWatchedHours": "Sponsored Watched Hours",
          "mediaValue": "Media Value",
          "likes": "Likes",
          "comments": "Comments",
          "engagements": "Engagements",
          "engagementRate": "Engagement Rate",
          "engagementRateViews": "Engagement Rate (Views)",
          "predictedImpressions": "Predicted Impressions",
          "shares": "Shares",
          "impressions": "Impressions",
          "quotes": "Quotes",
          "retweets": "Retweets",
          "views": "Views",
          "reach": "Reach"
        },
        "deliverable": {
          "status": {
            "processing": "Processing",
            "ok": "Completed",
            "problem": "Problem",
            "failed": "Failed"
          },
          "title": {
            "title": "Title",
            "tooltip": "Title",
            "shortInfo": "Count"
          },
          "gamePlay": {
            "title": "Gameplay",
            "tooltip": "Gameplay"
          },
          "chatBot": {
            "title": "Chatbot",
            "tooltip": "Chatbot"
          },
          "chatbotMulti": {
            "title": "Chatbot and Command",
            "tooltip": "Chatbot and Command"
          },
          "talkingPoint": {
            "title": "Audio Mentions",
            "tooltip": "Audio Mentions",
            "shortInfo": "Count"
          },
          "talkingPointAi": {
            "title": "Talking Point",
            "tooltip": "Talking Point",
            "shortInfo": "Count"
          },
          "productPlacement": {
            "title": "Product Placements",
            "tooltip": "Product Placements"
          },
          "visual": {
            "title": "Visual",
            "tooltip": "Visual"
          },
          "showcase": {
            "title": "Showcase",
            "tooltip": "Showcase"
          },
          "custom": {
            "title": "Custom",
            "tooltip": "Custom"
          },
          "textTracking": {
            "title": "Text Tracking",
            "tooltip": "Text Tracking",
            "shortInfo": "Count"
          },
          "audioTracking": {
            "title": "Audio Tracking",
            "tooltip": "Audio Tracking",
            "shortInfo": "Count"
          },
          "caption": {
            "title": "Caption",
            "tooltip": "Caption",
            "shortInfo": "Count"
          },
          "hashTag": {
            "title": "Hashtag",
            "tooltip": "Hashtag",
            "shortInfo": "Count"
          },
          "mention": {
            "title": "Mention",
            "tooltip": "Mention",
            "shortInfo": "Count"
          },
          "message": {
            "title": "Message",
            "tooltip": "Message",
            "shortInfo": "Count"
          },
          "description": {
            "title": "Description",
            "tooltip": "Description",
            "shortInfo": "Count"
          },
          "content": {
            "title": "Content",
            "tooltip": "Content",
            "shortInfo": "Count"
          }
        }
      }
    },
    "creators": {
      "banner": {
        "title": "Creators",
        "campaigns": "Campaigns with this Creator",
        "creatorCampaigns": "Your campaigns"
      },
      "datatable": {
        "newCreator": "Add Creator",
        "deleteCreator": "Delete creator",
        "deleteCreatorMessage": "Are you sure you want to delete \"{{ name }}\"?"
      }
    },
    "creatorDetails": {
      "newCreator": "New creator",
      "namePlaceholder": "Optional custom name",
      "create": "Create",
      "creatorNotParticipatingInCampaigns": "This creator is not participating in any campaigns.",
      "youDoNotHaveAnyActiveCampaigns": "You do not have any active campaigns.",
      "tabs": {
        "overview": "Overview",
        "campaigns": "Campaigns",
        "channels": "Channels",
        "contents": "Contents",
        "deliverables": "Deliverables"
      },
      "creatorInvitation": {
        "invite": "Invite",
        "invited": "Invited",
        "accepted": "Accepted",
        "expired": "Expired",
        "notYetAccepted": "Not yet accepted",
        "dialog": {
          "title": "Invite {{name}}",
          "sendInvitation": "Send invitation",
          "sendAnotherInvitation": "Send another invitation",
          "revoke": "Revoke",
          "revokeMessage": "Revoking the invitation will cause the creator to lose access to the platform. Are you sure you want to revoke the invitation for {{ email }}?",
          "email": "Email",
          "message": "Message",
          "invitationSent": "Invitation sent successfully",
          "invitationRevoked": "Invitation revoked successfully",
          "accepted": "Invitation accepted",
          "expired": "Invitation expired on {{expiryDate}}",
          "notYetAccepted": "Invitation not yet accepted, expires on {{expiryDate}}",
          "defaultMessage": "You are invited to join the Shikenso Campaign app."
        },
        "deleteInvitation": {
          "title": "Revoke invitation",
          "message": "Are you sure you want to revoke this invitation? This creator will lose access to the platform.",
          "confirmText": "Revoke",
          "cancelText": "Cancel"
        }
      },
      "addPlatform": {
        "addChannel": "Add Channel",
        "addPlatformTitle": "Add Platform",
        "addCreatorTitle": "Add Creator"
      },
      "socialContentDialog": {
        "noAnalyticsAvailable": "No analytics available without campaign context."
      },
      "deliverables": {
        "filter": {
          "scope": "Scope",
          "allCampaigns": "All campaigns",
          "timeRange": "Time Range",
          "thisWeek": "This week",
          "thisMonth": "This month",
          "allTime": "Full period",
          "last7Days": "Last 7 days",
          "last30Days": "Last 30 days",
          "custom": "Custom",
          "customRange": "Custom range"
        },
        "campaignsLoadError": "Failed to load campaigns. Please try again.",
        "loadError": "Failed to load deliverables. Please try again later.",
        "retry": "Retry"
      }
    },
    "customers": {
      "banner": {
        "title": "Clients",
        "campaigns": "Campaigns with this Client"
      },
      "datatable": {
        "newCustomer": "Add Client",
        "deleteCustomer": "Delete Client",
        "deleteCustomerMessage": "Are you sure you want to delete \"{{ name }}\"?"
      }
    },
    "channels": {
      "firstChannelPlaceholder": "Enter URL to add platform. The creator's name and icon will be added automatically.",
      "urlPlaceholder": "Enter URL to add another platform",
      "noUrlPlaceholder": "This creator contains no platforms. Add one to use him inside this campaign.",
      "banner": {
        "title": "Channels"
      },
      "datatable": {
        "createChannel": "Create channel",
        "newChannel": "New channel",
        "deleteChannel": "Delete channel",
        "deleteChannelMessage": "Are you sure you want to delete \"{{ name }}\"?",
        "addChannelInput": "Enter URL to add another platform",
        "channelHasNoImagePleaseRefresh": "This channel has no image. Please refresh the image."
      },
      "buttons": {
        "add": "Add"
      }
    },
    "customerDetails": {
      "newCustomer": "New client",
      "namePlaceholder": "Add client name",
      "create": "Create",
      "customerNotParticipatingInCampaigns": "This client is not participating in any campaigns.",
      "tabs": {
        "campaigns": "Campaigns"
      }
    },
    "dashboard": {
      "banner": {
        "title": "Dashboard",
        "news": "News"
      },
      "campaigns": {
        "ended": "Ended",
        "endsIn": "Ends in {{timeRemaining}}"
      }
    },
    "settings": {
      "templateSettings": {
        "title": "Global Templates",
        "description": "Define templates for all CTA requirements across platforms.",
        "addGlobalTemplate": "Create Template",
        "globalTemplate": "Global Template",
        "mergeDialog": {
          "title": "Existing Template",
          "message": "This template already exists. Do you want to edit this one instead?",
          "confirm": "Continue",
          "cancel": "Cancel"
        }
      },
      "accountPanel": "Account Panel",
      "userManagement": {
        "title": "User Management",
        "description": "Manage your team members, their roles and teams.",
        "tabs": {
          "users": "Users",
          "rolesTeams": "Roles & Teams"
        },
        "users": {
          "inviteUser": "Invite User",
          "changeRole": "Change role",
          "changeTeam": "Change team",
          "noTeam": "No team",
          "deleteUserMessage": "Are you sure you want to delete {{name}}?",
          "deleteUserError": "User could not be deleted.",
          "resendInvitation": "Resend invitation",
          "resendInvitationError": "Invitation could not be resent.",
          "invitationSent": "Invitation sent successfully",
          "invitationRevoked": "Invitation revoked successfully",
          "revokeInvitationError": "Invitation could not be revoked.",
          "kpis": {
            "seatsUsed": {
              "title": "Seats Used",
              "info": "The number of seats currently used out of your total available seats."
            },
            "pendingInvites": {
              "title": "Pending Invites",
              "info": "The number of invitations that have been sent but not yet accepted."
            }
          },
          "inviteUserDialog": {
            "title": "Invite user",
            "emailPlaceholder": "Email",
            "rolePlaceholder": "Role",
            "teamPlaceholder": "Team",
            "messagePlaceholder": "Message",
            "sendInvite": "Send Invite"
          },
          "cannotManageUserRole": "You can only manage roles for users with permissions equal to or lower than your own.",
          "cannotManageUserTeam": "You do not have permission to change this user's team.",
          "lastAdminCannotChange": "The last administrator role cannot be changed or reassigned.",
          "lastAdminCannotDelete": "The last administrator cannot be deleted.",
          "expiredInvitationMessage": "Expired invitations cannot be edited."
        },
        "roles": {
          "campaign": "Admin",
          "campaignSub": "Member"
        },
        "selectRoleDialog": {
          "title": "Select Role",
          "addCustomRole": "Add custom role",
          "cannotAssignRole": "You can only assign roles with permissions equal to or lower than your own."
        },
        "selectTeamDialog": {
          "title": "Select Team",
          "addTeam": "Add team"
        },
        "addTeamDialog": {
          "titleCreate": "Add Team",
          "titleEdit": "Edit team",
          "namePlaceholder": "Name",
          "uploadTitle": "Select media to upload (optional)",
          "uploadMaxSize": "Max size 50MB",
          "uploadFormats": "gif, jpg or png"
        },
        "addCustomRoleDialog": {
          "defaultName": "Custom Role {{ number }}",
          "titleCreate": "Add Custom Role",
          "titleEdit": "Edit Custom Role",
          "titleView": "View permissions",
          "namePlaceholder": "Name",
          "headingCreate": "Custom Role Permissions",
          "headingEditOrView": "Role Permissions",
          "headingDescription": "A role is a collection of permissions applied to every user assigned to it.",
          "systemRoleBadge": "System role",
          "systemRoleCaption": "This role can not be edited",
          "noSectionPermissions": "No {{ sectionTitle }} permissions",
          "cannotManagePermission": "You can only manage permissions you currently hold.",
          "cannotEditRolePermissionMessage": "You can only edit roles with permissions equal to or lower than your own."
        },
        "rolePermissions": {
          "toggles": {
            "create": "Create",
            "view": "View",
            "edit": "Edit",
            "delete": "Delete"
          },
          "campaigns": {
            "title": "Campaigns",
            "description": "Controls what this role can view, create, edit, delete, and publish for campaigns.",
            "manualDeliverablesStatus": "Manual Deliverable Status",
            "manualMatchingStatus": "Manual Matching Status",
            "findingDetection": "Finding Deletion"
          },
          "creators": {
            "title": "Creators",
            "description": "Controls what this role can view and manage for creators.",
            "auth": "Auth",
            "invitation": "Invitation"
          },
          "clients": {
            "title": "Clients",
            "description": "Controls what this role can view and manage for clients."
          },
          "userManagement": {
            "title": "User Management",
            "description": "Controls what this role can manage for users and teams.",
            "manage": "Manage"
          }
        },
        "rolesTeamsTab": {
          "roles": {
            "title": "Roles",
            "description": "A role is a collection of permissions. Each user is assigned exactly one role."
          },
          "teams": {
            "title": "Teams",
            "description": "A team is a collection of users. Each user belongs to exactly one team."
          },
          "userCount": "{{ count }} users",
          "userCountSingular": "1 user",
          "menu": {
            "viewPermissions": "View permissions",
            "editPermissions": "Edit permissions",
            "editTeam": "Edit team"
          },
          "deleteRoleMessage": "Are you sure you want to delete the role \"{{ name }}\"?",
          "deleteTeamMessage": "Are you sure you want to delete the team \"{{ name }}\"?",
          "deleteRoleError": "Role could not be deleted.",
          "deleteTeamError": "Team could not be deleted.",
          "cannotDeleteRolePermissionMessage": "You can only delete roles with permissions equal to or lower than your own.",
          "roleHasMembersMessage": "Roles with assigned users cannot be deleted.",
          "roleHasPendingInvitationsMessage": "Roles with pending invitations cannot be deleted.",
          "teamHasMembersMessage": "Teams with assigned members cannot be deleted.",
          "teamHasPendingInvitationsMessage": "Teams with pending invitations cannot be deleted."
        },
        "discardChangesDialog": {
          "title": "Unsaved Changes",
          "message": "You have unsaved changes. Are you sure you want to leave?",
          "confirm": "Discard",
          "cancel": "Continue Editing"
        }
      }
    },
    "profile": {
      "banner": {
        "title": "Profile",
        "signOut": "Sign out"
      },
      "linkedAccounts": {
        "title": "Link accounts",
        "description": "You can link your other social accounts to login with them.",
        "unlink": "Unlink",
        "link": "Link",
        "success": "Account linked successfully",
        "error": "Failed to link account",
        "unlinkSuccess": "Account unlinked successfully",
        "unlinkError": "Failed to unlink account"
      },
      "aiAssistants": {
        "title": "AI assistants",
        "description": "Ask Claude, ChatGPT or other AI apps about your campaign data.",
        "descriptionWithoutChatGpt": "Ask Claude or other AI apps about your campaign data.",
        "otherAppsSubtitle": "Cursor, VS Code and other MCP clients",
        "connect": "Connect",
        "connectAriaLabel": "Connect {{app}}"
      },
      "language": {
        "title": "Language",
        "english": "English",
        "german": "German"
      },
      "buttons": {
        "saveUser": "Save User",
        "changePassword": "Change Password"
      },
      "form": {
        "name": "Name"
      },
      "fileUpload": {
        "chooseFile": "Choose file",
        "uploadNewImage": "Upload new image",
        "UploadImage": "Upload image"
      },
      "header": {
        "general": "General"
      }
    },
    "login": {
      "welcomeBack": "Welcome back",
      "enterYourCredentials": "Enter your credentials to sign in or sign in using a social network below",
      "continueWithGoogle": "Continue with Google",
      "continueWithFacebook": "Continue with Facebook",
      "continueWithX": "Continue with X",
      "or": "or",
      "email": "Email",
      "password": "Password",
      "forgotPassword": "Forgot password?",
      "continue": "Continue",
      "signIn": "Sign in",
      "emailRequired": "Email is required",
      "emailInvalid": "Please enter a valid email address",
      "passwordRequired": "Password is required",
      "quote": "Being able to provide value and insight for our partners is crucial to creating sustainable, successful and long-term brand collaborations.",
      "author": "Oliver Clarke",
      "authorTitle": "Commercial Director, BLAST",
      "snackbar": {
        "accountNotLinkedWithGoogle": "This Google account is not linked to an existing account. Please link it to an existing account to sign in.",
        "accountNotLinkedWithFacebook": "This Facebook account is not linked to an existing account. Please link it to an existing account to sign in.",
        "accountNotLinkedWithTwitter": "This Twitter account is not linked to an existing account. Please link it to an existing account to sign in.",
        "pleaseEnterEmail": "Please enter your email address.",
        "invalidCredentials": "Invalid email or password. Please try again.",
        "passwordResetSuccess": "Password reset email sent. Please check your inbox.",
        "passwordResetError": "Error sending password reset email. Please try again."
      },
      "afterPasswordResetMessage": "Password saved! You've successfully updated your password.",
      "afterPasswordForgotMessage": "Please check your inbox to reset your password."
    },
    "forgotPassword": {
      "title": "Forgot password?",
      "description": "Happens to the best of us! Enter your email and we will send you a reset link.",
      "sendResetLink": "Send reset link",
      "checkInbox": "Check your inbox",
      "emailSent": "We've sent you an email with instructions to reset your password.",
      "backToSignIn": "Back to sign in"
    },
    "createPassword": {
      "title": "Create password",
      "description": "Create a password to sign in to your account.",
      "createPassword": "Create password",
      "password": "Password",
      "confirmPassword": "Confirm password"
    },
    "maintenance": {
      "title": "Maintenance",
      "description": "Our system is currently undergoing scheduled maintenance. We'll be back shortly."
    },
    "notFound": {
      "title": "Not Found",
      "sharedTitle": "Shared Page Not Found",
      "description": "Please check the URL and try again."
    },
    "changePassword": {
      "title": "Change password",
      "description": "Enter your current and new password to change your password.",
      "changePassword": "Change password",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "confirmNewPassword": "Confirm new password",
      "passwordChanged": "Password changed successfully"
    },
    "newPassword": {
      "title": "New password",
      "description": "Create a new password for your account.",
      "newPassword": "New password",
      "confirmNewPassword": "Confirm new password",
      "resetPassword": "Reset password",
      "invalidCode": "Password reset code is invalid. Please send yourself another email.",
      "resetFailed": "Failed to reset password. Please send yourself another email."
    }
  },
  "dialogs": {
    "createCampaignDialog": {
      "createCampaign": "Create Campaign",
      "createTitle": "Create New Campaign",
      "copyCta": "Copy",
      "copyNameSuffix": "Copy",
      "copyTitle": "Copy Campaign",
      "iconDescription": "This icon is the visual representation for this campaign inside the application.",
      "selectCampaignIconOptional": "Select Campaign icon (optional)",
      "updateTitle": "Update Campaign",
      "forbiddenDeliverable": "It is not possible to copy this campaign, because some deliverables have been globally deactivated.",
      "or": "or",
      "uploadBriefing": "Upload a briefing to create a campaign",
      "analyzingBrief": "We are analyzing your document",
      "briefAnalyzeError": "There was an error during document analysis. Please try again.",
      "briefMissingNameError": "This briefing didn't include a campaign name. Please enter one above and try again.",
      "submitError": "There was an error while saving your campaign. Please try again.",
      "briefWizard": {
        "title": "Fix Briefing Issues",
        "fixingIssueFor": "Fixing issue for: ",
        "fixingCampaignDetails": "Fixing campaign details: ",
        "briefValidateError": "There was an error during validation. Please try again.",
        "unrecognizedErrors": "This briefing has issues we couldn't display for you to fix directly. Please go back and re-check your document.",
        "deliverableGroupFallback": "Deliverable group {{ index }}",
        "stepCounter": "Issue {{ current }} / {{ total }}",
        "next": "Next",
        "back": "Back",
        "fix": "Fix",
        "fields": {
          "platformFeature": "Platform",
          "name": "Name",
          "duration": "Duration",
          "budget": "Budget",
          "notes": "Notes"
        },
        "platformStep": {
          "unsupportedDeliverables": "Doesn't support: {{ deliverables }}. They will be converted to manual Customs."
        },
        "executionStep": {
          "campaignDuration": "Campaign Duration: ",
          "campaignStarts": "Campaign Starts: ",
          "campaignEnds": "Campaign Ends: "
        },
        "warningsDialog": {
          "title": "Some deliverables need manual tracking",
          "message": "The following deliverables couldn't be tracked automatically and were converted to Customs:",
          "downgradedToCustom": "{{ deliverable }} is not available for {{ platformFeature }}, it will be converted to a \"Custom\" deliverable. The obligation stands, but it now has to be checked manually for every content instead of being tracked.",
          "continue": "Continue",
          "back": "Back to file"
        },
        "leaveConfirm": {
          "title": "Leave without fixing?",
          "message": "Your campaign can't be created until these issues are fixed. If you leave now, your progress on this briefing will be lost.",
          "leave": "Leave",
          "keepFixing": "Keep Fixing"
        }
      }
    },
    "createCustomerDialog": {
      "createTitle": "Add Client",
      "updateTitle": "Update Client",
      "createCustomer": "Add Client",
      "iconDescription": "This icon is the visual representation for this client inside the application."
    },
    "accountTokenUsageWarning": {
      "title": "Account Processing Stopped",
      "message": "There are some issues with your account. Processing has stopped. Please contact Shikenso for more information."
    },
    "campaignTokenUsage": {
      "title": "Campaign Token Usage",
      "message": "Current token usage for this campaign.",
      "usageLabel": "Token Usage"
    }
  },
  "components": {
    "filteredCreatorBadge": {
      "filteredCreator": "Filtered Creator"
    },
    "circularGraph": {
      "bonus": "Bonus",
      "failed": "Failed",
      "problem": "Problem",
      "processing": "Processing",
      "remaining": "Remaining",
      "success": "Completed"
    },
    "fileUploader": {
      "selectMediaToUpload": "Select media to upload",
      "selectMediaToUploadOptional": "Select media to upload (optional)",
      "maxSize": "Max size {{ maxSize }}MB"
    },
    "budget": {
      "notDisclosed": "not disclosed",
      "noBudget": "no budget"
    },
    "addPlatformInput": {
      "platformAddedSuccessfully": "Platform added successfully.",
      "allowedPlatforms": "Allowed Platforms"
    },
    "kpiCard": {
      "names": {
        "concurrentCampaigns": "Concurrent Campaigns",
        "activeCampaigns": "Active Campaigns",
        "involvedCreators": "Involved Creators",
        "involvedCustomers": "Involved Clients",
        "creatorChannels": "Creator Channels",
        "activeCreators": "Active Creators",
        "avgChannelsPerCreator": "Avg. Channels",
        "avgCampaignsPerCreator": "Avg. Campaigns",
        "newCustomers": "New Clients",
        "activeCustomers": "Active Clients",
        "avgCampaignsPerCustomer": "Avg. Campaigns",
        "avgCreatorsPerCustomer": "Avg. Creators"
      }
    },
    "analyticsDetailsTable": {
      "noFindings": "There are no findings."
    },
    "userGroupSelect": {
      "noUserGroupsFound": "No user groups found"
    },
    "quillEditor": {
      "toolbar": {
        "bold": "Bold",
        "orderedList": "Ordered List",
        "bulletList": "Bullet List",
        "link": "Link",
        "heading1": "Heading 1",
        "heading2": "Heading 2",
        "heading3": "Heading 3",
        "normalText": "Normal text",
        "italic": "Italic",
        "underline": "Underline",
        "strike": "Strike",
        "quote": "Quote",
        "codeBlock": "Code block"
      }
    },
    "briefingNotes": {
      "globalTitle": "Global Briefing Notes",
      "globalDescription": "Visible to all creators in this campaign. Add instructions or supporting files if needed.",
      "creatorTitle": "Briefing Notes - {{creatorName}}",
      "creatorDescription": "These notes are visible only to {{creatorName}} and will override the global briefing notes. Add instructions or supporting files if needed.",
      "messageToCreators": "Message to creators",
      "messageToCreator": "Message to {{creatorName}}",
      "messagePlaceholder": "Add briefing instructions... e.g. required talking points, hashtags, sponsor mentions.",
      "attachments": "Attachments",
      "optional": "Optional",
      "fileUploadTitle": "Upload file or drag and drop",
      "briefingNotes": "Briefing Notes",
      "message": "Message",
      "noMessage": "No message",
      "noAttachments": "No attachments",
      "showMore": "Show more",
      "showLess": "Show less",
      "errors": {
        "textTooLong": "Message is too long",
        "htmlTooLarge": "Message is too large due to formatting"
      }
    },
    "socialContentFiles": {
      "attachments": "Attachments",
      "campaignManager": "Campaign Manager",
      "couldNotDeleteFile": "Could not remove file",
      "couldNotUploadDocument": "Could not upload document",
      "creator": "Creator",
      "downloadFile": "Download file",
      "fileUploadTitle": "Upload file",
      "imagePreview": "Image preview",
      "previewFile": "Preview file",
      "previewUnavailable": "Preview unavailable",
      "removeFile": "Remove file",
      "uploadInfo": "On {{ date }} by {{ author }}"
    },
    "customCreatorBadge": {
      "editing": "Editing"
    },
    "groupedDatatable": {
      "expandAll": "Expand All",
      "collapseAll": "Collapse All"
    }
  },
  "shared": {
    "hello": "Hello",
    "goodDay": "Good day",
    "welcomeBack": "Welcome back",
    "customer": "Client",
    "platforms": "Platforms",
    "platform": "Platform",
    "creators": "Creators",
    "customers": "Clients",
    "distribution": "Distribution",
    "followers": "Followers",
    "total": "Total",
    "status": "Status",
    "name": "Name",
    "delete": "Delete",
    "deleteAll": "Delete all",
    "revert": "Revert",
    "continue": "Continue",
    "cancel": "Cancel",
    "close": "Close",
    "live": "Live",
    "all": "All",
    "view": "View",
    "show": "Show",
    "ctaStatus": "Deliverables",
    "kpiStatus": "KPIs",
    "campaigns": "Campaigns",
    "submit": "Submit",
    "send": "Send",
    "resend": "Resend",
    "revoke": "Revoke",
    "search": "Search",
    "execution": "Execution",
    "deliverable": "Deliverable",
    "remove": "Remove",
    "lastChanged": "Last changed",
    "lastProcessed": "Last processed",
    "na": "N/A",
    "yes": "Yes",
    "no": "No",
    "globalStatus": "Global Status",
    "started": "Started",
    "zoom": "Zoom",
    "videoPlayerNotSupported": "Your browser does not support this video player.",
    "notAvailable": "Not available",
    "notSet": "Not set",
    "noKpis": "No KPIs",
    "id": "ID",
    "clear": "Clear",
    "startInitial": "S",
    "endInitial": "E",
    "userGroup": "User group",
    "creator": "Creator",
    "message": "Message",
    "email": "Email",
    "url": "URL",
    "progress": "Progress",
    "channel": "Channel",
    "authentication": "Authentication",
    "authenticateGuide": "Authenticate Guide",
    "authenticated": "Authenticated",
    "notAuthenticated": "Not Authenticated",
    "notRequired": "Not Required",
    "required": "Required",
    "authenticate": "Authenticate",
    "notifications": "Notifications",
    "add": "Add",
    "more": "More",
    "selectAll": "Select all",
    "unselectAll": "Unselect all",
    "expandAll": "Expand All",
    "collapseAll": "Collapse All",
    "override": "Override",
    "upload": "Upload",
    "appUpdate": {
      "cancelText": "Not now",
      "confirmText": "Refresh",
      "message": "A new version is available. Refresh to update?",
      "title": "Update Available"
    },
    "tutorial": "Tutorial",
    "days": {
      "short": {
        "monday": "Mon",
        "tuesday": "Tue",
        "wednesday": "Wed",
        "thursday": "Thu",
        "friday": "Fri",
        "saturday": "Sat",
        "sunday": "Sun"
      },
      "long": {
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday"
      }
    },
    "bugReport": {
      "reportBug": "Report a bug",
      "contact": "Contact",
      "chat": "Chat",
      "chatUnavailable": "Chat is currently unavailable. Please try again later.",
      "bug": "Bug",
      "feedback": "Feedback",
      "message": "Message",
      "type": "Type",
      "feedbackTitle": "Feedback",
      "bugTitle": "Report Bug",
      "contactTitle": "Contact",
      "bugSuccess": "Bug report sent successfully.",
      "feedbackSuccess": "Feedback sent successfully.",
      "contactSuccess": "Email sent successfully."
    },
    "userFeedbackStatuses": {
      "new": "New",
      "open": "Open",
      "done": "Done"
    },
    "userFeedbackTypes": {
      "bug": "Bug",
      "feedback": "Feedback",
      "contact": "Contact"
    },
    "statuses": {
      "draft": "Draft",
      "setup": "Setup",
      "planned": "Planned",
      "live": "Live",
      "ended": "Ended",
      "archived": "Archived",
      "completed": "Completed",
      "bonus": "Bonus",
      "ok": "Completed",
      "problem": "Problem",
      "failed": "Failed",
      "found": "Found",
      "notFound": "Not found",
      "notStarted": "Not Started",
      "notSet": "Not Set",
      "processing": "Processing",
      "joined": "Joined",
      "kpiGoalsBelowTarget": "Below Target",
      "kpiGoalsFailed": "Failed",
      "kpiGoalsPlanned": "Planned",
      "kpiGoalsProcessing": "Processing",
      "kpiGoalsReached": "Reached",
      "kpiGoalsUnavailable": "Unavailable",
      "kpiGoalsNotStarted": "Not Started",
      "kpiGoalsNotSet": "Not Set",
      "kpiGoalsHealthy": "Healthy",
      "pending": "Pending",
      "expired": "Expired",
      "briefed": "Briefed",
      "done": "Done",
      "findings": "Findings",
      "noFindings": "No Findings",
      "missing": "Missing",
      "matched": "Matched",
      "fulfilled": "Fulfilled",
      "partiallyFulfilled": "Partially Fulfilled",
      "notFulfilled": "Not Fulfilled",
      "other": "Others",
      "atRisk": "At Risk",
      "healthy": "Healthy",
      "unrelated": "Unrelated"
    },
    "executionTypes": {
      "unique": "Unique",
      "undesignated": "Undesignated",
      "always": "Always"
    },
    "expectedKpis": {
      "peakViewers": "Peak Viewers",
      "averageViewers": "Average Viewers",
      "totalWatchedHours": "Watched Hours",
      "sponsoredAvgViewers": "Sponsored Average Viewers",
      "sponsoredAverageViewers": "Sponsored Average Viewers",
      "sponsoredPeakViewers": "Sponsored Peak Viewers",
      "sponsoredTotalWatchedHours": "Sponsored Watched Hours",
      "mediaValue": "Media Value",
      "likes": "Likes",
      "comments": "Comments",
      "engagements": "Engagements",
      "engagementRate": "Engagement Rate",
      "engagementRateViews": "Engagement Rate (Views)",
      "predictedImpressions": "Predicted Impressions",
      "shares": "Shares",
      "impressions": "Impressions",
      "quotes": "Quotes",
      "retweets": "Retweets",
      "views": "Views",
      "reach": "Reach"
    },
    "pagination": {
      "firstPage": "First page",
      "lastPage": "Last page",
      "nextPage": "Next page",
      "previousPage": "Previous page",
      "itemsPerPage": "Rows per page:",
      "paginationRange": "{{ range }} of {{ total }}"
    },
    "form": {
      "requiredField": "Required field",
      "changeName": "Change name",
      "changeImage": "Change image",
      "edit": "Edit",
      "delete": "Delete",
      "deleteCustomer": "Delete Client",
      "deleteCreator": "Delete creator",
      "export": "Export",
      "useImage": "Use image",
      "useAsDefault": "Use as default",
      "refreshImage": "Refresh image",
      "create": "Create",
      "update": "Update",
      "save": "Save",
      "saveAndExit": "Save & Exit",
      "submit": "Submit",
      "error": {
        "required": "This field is required.",
        "mustBeDecimal": "This field must be a decimal number with a maximum of 2 decimal places.",
        "mustBeNumber": "This field must be a number.",
        "invalidDuration": "Duration must be equal to or greater than 1.",
        "invalidExtension": "The image must be in jpg, jpeg, png, gif or webp format",
        "invalidFileExtension": "File extension is not allowed.",
        "maxLength": "The maximum length is {{ requiredLength }} characters.",
        "maxlength": "The maximum length is {{ requiredLength }} characters.",
        "maxFileSize": "Maximum file size is {{ maxSizeInMb }} MB.",
        "minLength": "The minimum length is {{ requiredLength }} characters.",
        "minlength": "The minimum length is {{ requiredLength }} characters.",
        "allFieldsRequired": "All fields are required.",
        "unknown": "An unknown error occurred.",
        "min": "Value must be greater than {{ min }}.",
        "gameNameNotExists": "Game name does not exist.",
        "durationDoesNotFitExecutions": "Durations does not fit executions.",
        "durationDoesNotFitGamePlays": "Duration does not fit gameplays.",
        "dateRange": "Not in campaign range.",
        "matTimepickerParse": "Invalid time format.",
        "matDatepickerParse": "Invalid date format.",
        "matTimepickerMax": "Must be before campaign end.",
        "matDatepickerMin": "Must be after campaign start.",
        "matTimepickerMin": "Must be after campaign start.",
        "email": "Invalid email address.",
        "roleNotAssignable": "This role is not assignable - you cannot invite someone into a role broader than your own.",
        "passwordsDoNotMatch": "Passwords do not match",
        "invalidDecimalNumberPasted": "Invalid number pasted.",
        "campaignDurationCannotBeLessThanOneHour": "Campaign duration cannot be less than 1 hour.",
        "emailUsedForAnotherCreator": "This email address is already used to invite the creator {{creatorName}}.",
        "cannotInviteSelf": "You cannot invite yourself.",
        "emailUsedInDifferentGroup": "This email address is already used to invite a creator in a different context.",
        "incorrectCurrentPassword": "Current password is incorrect.",
        "matEndDateInvalid": "End date cannot be before start date.",
        "matStartDateInvalid": "Start date invalid.",
        "executionsDoNotFitInCampaignRange": "Please make sure executions of {{ctaName}} fit in the campaign range.",
        "gamePlaysDoNotFitInCampaignRange": "Please make sure gameplays of {{ctaName}} fit in the campaign range.",
        "ctaNameAlreadyExists": "This name is already used for another template."
      },
      "customErrors": {
        "campaignDurationCannotBeLessThanOneHour": "Campaign duration cannot be less than 1 hour.",
        "emailUsedForAnotherCreator": "This email address is already used to invite the creator {{creatorName}}.",
        "matDatepickerMin": {
          "startDate": "Start date cannot be in the past.",
          "endDate": "End date cannot be earlier than the start date."
        },
        "matTimepickerMin": {
          "startTime": "Campaign must start at least 30 minutes from now.",
          "endTime": "Campaign duration cannot be less than 1 hour.",
          "executionTime": "Execution time cannot be earlier than the campaign start time."
        },
        "min": {
          "campaignCreatorCost": "Cost must be greater than {{ min }}."
        },
        "pattern": {
          "campaignCreatorCost": "Cost must be in the format of \"0.00\".",
          "videoTime": "Video time must be in the correct format. E.g. 00:00:00, 00:00, 00",
          "analyticsIdSearch": "Analytics ID must be in the correct format."
        },
        "dateRequiredWhenTimeIsSet": {
          "executionDate": "Date is required when time is set."
        },
        "invalidDecimalNumberPasted": {
          "campaignCreatorCost": "Invalid number pasted."
        },
        "required": {
          "executionDate": "This field is required."
        },
        "dateRange": {
          "executionTime": "Not in campaign range."
        },
        "intervalRange": {
          "minInterval": "Min. interval cannot be greater than max. interval.",
          "maxInterval": "Max. interval cannot be less than min. interval."
        }
      }
    },
    "subscription": {
      "enterprise": "Enterprise",
      "demo": "Demo",
      "admin": "Admin",
      "professional": "Professional",
      "starter": "Starter",
      "noSubscription": "No Subscription"
    },
    "platformFeatureGroups": {
      "twitchStream": "Twitch Stream Group",
      "youtubeStream": "Youtube Stream Group",
      "youtubeVod": "Youtube Video Group",
      "youtubeShort": "Youtube Shorts Group",
      "xPost": "X Post Group",
      "facebookPost": "Facebook Post Group",
      "facebookVideo": "Facebook Video Group",
      "tikTokPost": "Tiktok Post Group",
      "instagramPost": "Instagram Post Group",
      "instagramReel": "Instagram Reel Group",
      "instagramStory": "Instagram Story Group"
    },
    "platformFeatures": {
      "twitchStream": "Twitch Stream",
      "youtubeStream": "Youtube Stream",
      "youtubeVod": "Youtube Video",
      "youtubeShort": "Youtube Shorts",
      "xPost": "X Post",
      "facebookPost": "Facebook Post",
      "facebookVideo": "Facebook Video",
      "tikTokPost": "Tiktok Post",
      "instagramPost": "Instagram Post",
      "instagramReel": "Instagram Reel",
      "instagramStory": "Instagram Story",
      "twitch": "Twitch",
      "youtube": "Youtube",
      "tiktok": "Tiktok",
      "facebook": "Facebook",
      "x": "X",
      "instagram": "Instagram"
    },
    "deliverableTypes": {
      "title": "Title",
      "banner": "Banner",
      "chatBot": "Chatbot and Command",
      "chatbotMulti": "Chatbot and Command",
      "talkingPoint": "Audio Mention",
      "talkingPointAi": "Talking Point",
      "gamePlay": "Gameplay",
      "visual": "Visual",
      "showcase": "Showcase",
      "productPlacement": "Product Placement",
      "textTracking": "Text Tracking",
      "audioTracking": "Audio Tracking",
      "caption": "Caption",
      "hashTag": "Hashtag",
      "mention": "Mention",
      "message": "Message",
      "description": "Description",
      "content": "Content",
      "custom": "Custom"
    },
    "tile": {
      "deliverables": "Deliverables",
      "kpiGoals": "KPI-Goals",
      "moreItems": "+{{ count }} more",
      "anyTime": "Any time",
      "alwaysRequired": "Always required",
      "failedDeliverables": "{{ count }} failed deliverables",
      "problematicDeliverables": "{{ count }} problematic deliverables",
      "kpiBelow": "{{ count }} KPI below",
      "kpiFailed": "{{ count }} KPI failed",
      "clickToSeeDetails": "Click to see details",
      "bonusDeliverables": "{{ current }}/{{ expected }} bonus deliverables",
      "observations": "{{ count }} observation(s)",
      "yesterday": "Yesterday",
      "today": "Today",
      "tomorrow": "Tomorrow"
    },
    "deliverableActions": {
      "manuallyAccept": "Manually accept",
      "manuallyReject": "Manually reject",
      "removeManualStatus": "Remove manual status",
      "statusCannotBeChangeCampaignNotLive": "Status cannot be changed because the campaign is not live.",
      "success": "Manual status updated successfully, analytics data will be updated in a few minutes.",
      "processing": "Analytics data is still being processed.",
      "manualOverridePossible": "(Manual override possible)",
      "manualOverrideNotPossible": "(Manual override not possible)",
      "manualOverrideCanBeChanged": "(Manual override can be changed)"
    },
    "processingTime": {
      "processingTime": "Processing time",
      "nearTime": "Near-Time",
      "hours": "Hours",
      "oneToThreeDays": "1-3 days",
      "none": "None"
    },
    "analyticsStatus": {
      "processing": "Processing",
      "ok": "Completed",
      "problem": "Problem",
      "failed": "Failed",
      "manuallyAccepted": "Completed (manual)",
      "manuallyRejected": "Failed (manual)"
    },
    "matchingActions": {
      "markAsMatched": "Mark as matched",
      "markAsUnmatched": "Mark as unmatched",
      "removeManualMatching": "Remove manual override",
      "success": "Manual override updated successfully, analytics data will be updated in a few minutes.",
      "manualOverridePossible": "(Manual override possible)",
      "manualOverrideNotPossible": "(Manual override not possible)",
      "manuallyMatchedRecalculating": "(Manually matched, status is being recalculated)",
      "manuallyMatchedOverridePossible": "(Manually matched, override possible)",
      "manuallyMatchedOverrideNotPossible": "(Manually matched, override not possible)",
      "manuallyUnmatchedRecalculating": "(Manually unmatched, status is being recalculated)",
      "manuallyUnmatchedOverridePossible": "(Manually unmatched, override possible)",
      "manuallyUnmatchedOverrideNotPossible": "(Manually unmatched, override not possible)",
      "manualStatusRemovedRecalculating": "(Manual override removed, status is being recalculated)"
    },
    "tooltips": {
      "remove": "Remove"
    },
    "numberSuffix": {
      "billion": "B",
      "million": "M",
      "thousand": "K"
    },
    "timeSuffix": {
      "hour": "h",
      "minute": "m",
      "second": "s"
    },
    "timeSuffixLong": {
      "hours": "hour(s)",
      "minutes": "minute(s)",
      "seconds": "second(s)",
      "days": "day(s)",
      "hoursPlural": "hours",
      "minutesPlural": "minutes",
      "secondsPlural": "seconds",
      "daysPlural": "days",
      "hourSingular": "hour",
      "minuteSingular": "minute",
      "secondSingular": "second",
      "daySingular": "day"
    },
    "timeSuffixMedium": {
      "hours": "hrs",
      "minutes": "mins",
      "seconds": "secs"
    },
    "userGroupId": "User group ID",
    "createdAt": "Created at",
    "createdBy": "Created by",
    "noResults": "No results found",
    "changesSavedSuccessfully": "Changes saved successfully.",
    "invalidUrlId": "Incorrect ID inside the URL, please check the ID and try again.",
    "save": "Save",
    "dateTimeRangeFields": {
      "startDate": "Start date",
      "startDatePlaceholder": "Start date",
      "startTimePlaceholder": "Start time",
      "endDate": "End date",
      "endDatePlaceholder": "End date",
      "endTimePlaceholder": "End time"
    },
    "aiConnector": {
      "title": "Connect Shikenso with your AI",
      "subtitle": "Ask your AI assistant about your campaign data.",
      "benefits": {
        "dataTitle": "Ask about your data",
        "dataText": "Straight from your campaign, no export needed",
        "reportingTitle": "Your own reporting",
        "reportingText": "Summaries and comparisons, built in your AI chat"
      },
      "tabs": {
        "claude": "Claude",
        "chatgpt": "ChatGPT",
        "other": "Other apps"
      },
      "claude": {
        "step1": "Click \"Open in Claude\" – the Shikenso connector is added to your Claude account",
        "step2": "Sign in with your Shikenso username and password",
        "step3": "Ask away, e.g. \"Compare my last two campaigns\"",
        "openInClaude": "Open in Claude",
        "note": "On Claude Team or Enterprise, an admin may need to add the connector for your workspace first."
      },
      "chatgpt": {
        "step1": "In ChatGPT, open Settings → Apps & Connectors → Advanced and turn on Developer mode",
        "step2": "Click \"Create\", name it \"Shikenso\", paste the server URL below and choose OAuth",
        "step3": "Sign in with your Shikenso username and password",
        "note": "Requires ChatGPT Plus, Pro, Business or Enterprise. On Business and Enterprise an admin may need to enable this."
      },
      "other": {
        "text": "Add the server URL below as a remote MCP server (HTTP) in your client. When you connect, you will be asked to sign in with your Shikenso login."
      },
      "serverUrl": "Server URL",
      "copy": "Copy",
      "copied": "Server URL copied",
      "copyError": "Could not copy the server URL",
      "signInNote": "You sign in with your Shikenso login. Nothing is shared until you do.",
      "teaser": {
        "new": "New",
        "title": "Ask AI about your data",
        "text": "Connect Claude or ChatGPT to Shikenso and get answers straight from your campaigns.",
        "textWithoutChatGpt": "Connect Claude to Shikenso and get answers straight from your campaigns.",
        "connectNow": "Connect now",
        "dismiss": "Dismiss"
      }
    }
  },
  "apiErrorMessages": {
    "unknown": "An unexpected error occurred.",
    "notAuthorized": "You are not authorized to access this resource.",
    "notFound": {
      "id": "Entity not found.",
      "campaign": "Campaign not found."
    },
    "alreadyExists": {
      "channel": "This channel is already added to the creator {{creatorName}}.",
      "creatorChannel": "This channel is already added to this creator."
    },
    "customerNameAlreadyExists": {
      "name": "A customer named \"{{existingCustomerName}}\" already exists."
    },
    "creatorNameAlreadyExists": {
      "name": "A creator named \"{{existingCreatorName}}\" already exists."
    },
    "foreignKeyViolation": {
      "customerId": "Client does not exist.",
      "creatorId": "Creator does not exist.",
      "unknown": "An unknown data integrity error occurred."
    },
    "invalidEndDate": {
      "end": "End date cannot be earlier than the start date."
    },
    "invalidStartDate": {
      "start": "Start date cannot be in the past."
    },
    "userInactive": {
      "user": "Your account has been deactivated. Please contact support."
    },
    "invalidChannelUrl": "Platform not supported or not found, please check the URL",
    "invalidChannelId": "The channel ID is invalid.",
    "instagramNotBusinessOrNotFound": "Instagram channel not found or not a business account.",
    "channelNotFound": "Channel not found, please check the URL",
    "channelAlreadyExists": {
      "url": "This platform already has a channel added to the creator"
    },
    "channelNotFoundOnPlatform": "This channel does not exist on this platform, please check the URL",
    "briefingNotFound": "Briefing not found",
    "invalidDuration": "Gameplay duration exceeds execution duration.",
    "timestampOutOfRange": {
      "executions": "Execution times must be within the campaign time window."
    },
    "noCtas": {
      "ctaTemplates": "Campaigns that are not in draft mode must have at least one deliverable."
    },
    "creatorChannelMismatch": {
      "ctaTemplate": "Creator has no valid platform for some of the selected deliverables."
    },
    "noCreator": {
      "campaignCreators": "Creator has no valid platform for some of the selected deliverables."
    },
    "noTemplateWithCreator": {
      "ctaTemplates": "Campaigns that are not in draft mode must have at least one creator with at least one deliverable."
    },
    "annotatorUserOnly": {
      "isAnnotator": "Only annotator users can analyze the streams of this campaign."
    },
    "maxCreatorChannelsReached": {
      "creatorChannel": "You have reached the maximum number of creator channels. To add more, please upgrade your subscription, purchase a temporary increase in your limit or delete some of your creator channels."
    },
    "maxConcurrentCampaignsReached": {
      "campaign": "You have reached the maximum number of concurrent campaigns. To continue, please change your campaign dates, upgrade your subscription or purchase a temporary increase in your limit."
    },
    "creatorChannelLimit": {
      "currentCreatorChannels": "You have more than the allowed number of creator channels. To view analytics, either remove some creator channels, upgrade your subscription or purchase a temporary increase in your limit."
    },
    "concurrentCampaignLimit": {
      "currentConcurrentCampaigns": "You have more than the allowed number of concurrent campaigns. To view analytics, either change some of your campaign dates, wait till your campaigns are done, upgrade your subscription or purchase a temporary increase in your limit."
    },
    "endDateWriteReached": {
      "endDateWrite": "You have reached the end of your active period. You are only able to read already existing data, but not change it. To extend your active period, upgrade your subscription or purchase a temporary increase in your limit."
    },
    "endDateReadReached": {
      "endDateRead": "This user group is locked, because there is no active subscription or purchase. Usage of the campaign app is not allowed until you upgrade your subscription or purchase a temporary increase in your limit.",
      "userGroupSwitched": "This user group is locked, because there is no active subscription or purchase. To continue using this user group you need to upgrade your subscription or purchase a temporary increase in your limit. Since you also belong to another user group, you were automatically switched to this other user group. Page will reload in 5 seconds."
    },
    "notEnoughSeats": {
      "currentSeats": "You have more than the allowed number of seats. To continue, either remove some seats, upgrade your subscription or purchase a temporary increase in your limit."
    },
    "seatsLimit": {
      "currentSeats": "You have more than the allowed number of seats. To view analytics, either remove some seats, upgrade your subscription or purchase a temporary increase in your limit."
    },
    "campaignExportNameAlreadyExists": {
      "name": "A report with this name already exists."
    },
    "campaignHasEnded": {
      "status": "You cannot update a finished campaign."
    }
  },
  "field": {
    "briefed": "Briefed",
    "invited": "Invited",
    "name": "Name",
    "payout": "Payout",
    "platforms": "Platforms",
    "campaigns": "Campaigns",
    "actions": "Actions",
    "search": "Search",
    "kpi": "KPI",
    "kpiStatus": "KPIs",
    "ctaStatus": "Deliverables",
    "pay": "Pay",
    "customer": "Client",
    "startFormatted": "Start",
    "endFormatted": "End",
    "status": "Status",
    "deliverable": "Deliverable",
    "deliverableGroup": "Deliverable Group",
    "tracking": "Tracking",
    "findings": "Findings",
    "matching": "Matching",
    "matchingStatus": "Matching Status",
    "ctaKpiStatus": "Progress",
    "budget": "Budget",
    "created": "Created",
    "current": "Current",
    "currentConcurrentCampaigns": "Current Concurrent Campaigns",
    "maxConcurrentCampaigns": "Max Concurrent Campaigns",
    "effectiveMaxConcurrentCampaigns": "Max Concurrent Campaigns",
    "currentCreatorChannels": "Current Creator Channels",
    "maxCreatorChannels": "Max Creator Channels",
    "effectiveMaxCreatorChannels": "Max Creator Channels",
    "currentSeats": "Current Seats",
    "maxSeats": "Max Seats",
    "effectiveMaxSeats": "Max Seats",
    "endDateRead": "End Date Read",
    "endDateWrite": "End Date Write",
    "tokenUsage": "Token Usage",
    "expected": "Expected",
    "icon": "Icon",
    "userGroupId": "User Group ID",
    "firebaseUid": "Firebase UID",
    "email": "Email",
    "createdAt": "Created At",
    "createdByUserName": "Created By",
    "message": "Message",
    "creator": "Creator",
    "campaign": "Campaign",
    "date": "Date",
    "type": "Type",
    "userId": "User ID",
    "deliverables": "Deliverables",
    "observation": "Observation",
    "observations": "Observations",
    "target": "Target",
    "kpis": "KPIs",
    "createdBy": "Created By",
    "userGroup": "User Group",
    "activeUsers": "Active Users",
    "campaignsStarted": "Campaigns Started",
    "campaignsFinished": "Campaigns Finished",
    "campaignCompletion": "Campaign Completion",
    "reportsCreated": "Reports Created",
    "reportAdoption": "Report Adoption",
    "briefingsCreated": "Briefings Created",
    "briefingAdoption": "Briefing Adoption",
    "avgCompletionTime": "Avg. Completion Time",
    "group": "Group",
    "campaignsCompleted": "Campaigns Completed",
    "completionPercentage": "Completion %",
    "userName": "User Name",
    "role": "Role",
    "team": "Team",
    "roleName": "Role",
    "teamName": "Team",
    "start": "Start",
    "end": "End",
    "priority": "Priority",
    "title": "Title"
  }
} as const;
